/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LogoutReturnImport } from './routes/logout-return'
import { Route as LoginImport } from './routes/login'
import { Route as ForbiddenImport } from './routes/forbidden'
import { Route as SinglePageImport } from './routes/_single-page'
import { Route as AuthImport } from './routes/_auth'
import { Route as SinglePageLinkImport } from './routes/_single-page/link'
import { Route as AuthLogoutImport } from './routes/_auth/logout'
import { Route as AuthPlayerImport } from './routes/_auth/_player'
import { Route as AuthGlobalImport } from './routes/_auth/_global'
import { Route as AuthGlobalIndexImport } from './routes/_auth/_global/index'
import { Route as SinglePageAccountVerificationImport } from './routes/_single-page/account.verification'
import { Route as SinglePageAccountRecoveryImport } from './routes/_single-page/account.recovery'
import { Route as SinglePageAccountProfileImport } from './routes/_single-page/account.profile'
import { Route as AuthGameserverGameServerIdImport } from './routes/_auth/gameserver.$gameServerId'
import { Route as AuthDomainSelectImport } from './routes/_auth/domain.select'
import { Route as AuthDomainDisabledImport } from './routes/_auth/domain.disabled'
import { Route as AuthGlobalVariablesImport } from './routes/_auth/_global/variables'
import { Route as AuthGlobalUsersImport } from './routes/_auth/_global/users'
import { Route as AuthGlobalSettingsImport } from './routes/_auth/_global/settings'
import { Route as AuthGlobalRolesImport } from './routes/_auth/_global/roles'
import { Route as AuthGlobalPlayersImport } from './routes/_auth/_global/players'
import { Route as AuthGlobalModulesImport } from './routes/_auth/_global/modules'
import { Route as AuthGlobalGameserversImport } from './routes/_auth/_global/gameservers'
import { Route as AuthGlobalEventsImport } from './routes/_auth/_global/events'
import { Route as AuthGlobalDashboardImport } from './routes/_auth/_global/dashboard'
import { Route as AuthGlobalAnalyticsImport } from './routes/_auth/_global/analytics'
import { Route as AuthModuleBuilderModuleIdIndexImport } from './routes/_auth/module-builder.$moduleId.index'
import { Route as AuthGlobalSettingsIndexImport } from './routes/_auth/_global/settings/index'
import { Route as AuthGlobalAnalyticsIndexImport } from './routes/_auth/_global/analytics/index'
import { Route as AuthModuleBuilderModuleIdModuleVersionTagImport } from './routes/_auth/module-builder.$moduleId.$moduleVersionTag'
import { Route as AuthGameserverGameServerIdShopImport } from './routes/_auth/gameserver.$gameServerId/shop'
import { Route as AuthGameserverGameServerIdSettingsImport } from './routes/_auth/gameserver.$gameServerId/settings'
import { Route as AuthGameserverGameServerIdModulesImport } from './routes/_auth/gameserver.$gameServerId/modules'
import { Route as AuthGameserverGameServerIdItemsImport } from './routes/_auth/gameserver.$gameServerId/items'
import { Route as AuthGameserverGameServerIdDashboardImport } from './routes/_auth/gameserver.$gameServerId/dashboard'
import { Route as AuthPlayerShopGameServerIdImport } from './routes/_auth/_player/shop.$gameServerId'
import { Route as AuthGlobalVariablesCreateImport } from './routes/_auth/_global/variables.create'
import { Route as AuthGlobalUserUserIdImport } from './routes/_auth/_global/user.$userId'
import { Route as AuthGlobalSettingsGameserversImport } from './routes/_auth/_global/settings/gameservers'
import { Route as AuthGlobalSettingsDiscordImport } from './routes/_auth/_global/settings/discord'
import { Route as AuthGlobalRolesCreateImport } from './routes/_auth/_global/roles.create'
import { Route as AuthGlobalPlayerPlayerIdImport } from './routes/_auth/_global/player.$playerId'
import { Route as AuthGlobalAnalyticsShopImport } from './routes/_auth/_global/analytics/shop'
import { Route as AuthGameserverGameServerIdShopIndexImport } from './routes/_auth/gameserver.$gameServerId/shop.index'
import { Route as AuthPlayerShopGameServerIdIndexImport } from './routes/_auth/_player/shop.$gameServerId.index'
import { Route as AuthGlobalSettingsBillingIndexImport } from './routes/_auth/_global/settings/billing/index'
import { Route as AuthGlobalPlayerPlayerIdIndexImport } from './routes/_auth/_global/player.$playerId/index'
import { Route as AuthGlobalModulesCreateIndexImport } from './routes/_auth/_global/modules.create.index'
import { Route as AuthGlobalGameserversCreateIndexImport } from './routes/_auth/_global/gameservers.create.index'
import { Route as AuthGameserverGameServerIdShopOrdersImport } from './routes/_auth/gameserver.$gameServerId/shop.orders'
import { Route as AuthGameserverGameServerIdShopCategoriesImport } from './routes/_auth/gameserver.$gameServerId/shop.categories'
import { Route as AuthGameserverGameServerIdDashboardStatisticsImport } from './routes/_auth/gameserver.$gameServerId/dashboard.statistics'
import { Route as AuthGameserverGameServerIdDashboardPlayersImport } from './routes/_auth/gameserver.$gameServerId/dashboard.players'
import { Route as AuthGameserverGameServerIdDashboardOverviewImport } from './routes/_auth/gameserver.$gameServerId/dashboard.overview'
import { Route as AuthGameserverGameServerIdDashboardConsoleImport } from './routes/_auth/gameserver.$gameServerId/dashboard.console'
import { Route as AuthPlayerShopGameServerIdOrdersImport } from './routes/_auth/_player/shop.$gameServerId.orders'
import { Route as AuthGlobalVariablesViewVariableIdImport } from './routes/_auth/_global/variables.view.$variableId'
import { Route as AuthGlobalVariablesUpdateVariableIdImport } from './routes/_auth/_global/variables.update.$variableId'
import { Route as AuthGlobalRolesViewRoleIdImport } from './routes/_auth/_global/roles.view.$roleId'
import { Route as AuthGlobalRolesUpdateRoleIdImport } from './routes/_auth/_global/roles.update.$roleId'
import { Route as AuthGlobalPlayerPlayerIdInventoryImport } from './routes/_auth/_global/player.$playerId/inventory'
import { Route as AuthGlobalPlayerPlayerIdInfoImport } from './routes/_auth/_global/player.$playerId/info'
import { Route as AuthGlobalPlayerPlayerIdEventsImport } from './routes/_auth/_global/player.$playerId/events'
import { Route as AuthGlobalPlayerPlayerIdEconomyImport } from './routes/_auth/_global/player.$playerId/economy'
import { Route as AuthGlobalModulesCreateImportImport } from './routes/_auth/_global/modules.create.import'
import { Route as AuthGlobalModulesModuleIdUpdateImport } from './routes/_auth/_global/modules.$moduleId.update'
import { Route as AuthGlobalGameserversUpdateGameServerIdImport } from './routes/_auth/_global/gameservers.update.$gameServerId'
import { Route as AuthGlobalGameserversCreateImportImport } from './routes/_auth/_global/gameservers.create.import'
import { Route as AuthGlobalModulesModuleIdViewIndexImport } from './routes/_auth/_global/modules.$moduleId.view.index'
import { Route as AuthGameserverGameServerIdShopListingCreateImport } from './routes/_auth/gameserver.$gameServerId/shop.listing.create'
import { Route as AuthGameserverGameServerIdShopCategoriesCreateImport } from './routes/_auth/gameserver.$gameServerId/shop.categories.create'
import { Route as AuthGlobalUserUserIdRoleAssignImport } from './routes/_auth/_global/user.$userId.role.assign'
import { Route as AuthGlobalPlayerPlayerIdRoleAssignImport } from './routes/_auth/_global/player.$playerId/role.assign'
import { Route as AuthGlobalModulesModuleIdViewModuleVersionTagImport } from './routes/_auth/_global/modules.$moduleId.view.$moduleVersionTag'
import { Route as AuthGameserverGameServerIdShopListingImportGameserverImport } from './routes/_auth/gameserver.$gameServerId/shop.listing.import.gameserver'
import { Route as AuthGameserverGameServerIdShopListingImportFileImport } from './routes/_auth/gameserver.$gameServerId/shop.listing.import.file'
import { Route as AuthGameserverGameServerIdShopListingShopListingIdViewImport } from './routes/_auth/gameserver.$gameServerId/shop.listing.$shopListingId.view'
import { Route as AuthGameserverGameServerIdShopListingShopListingIdUpdateImport } from './routes/_auth/gameserver.$gameServerId/shop.listing.$shopListingId.update'
import { Route as AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateImport } from './routes/_auth/gameserver.$gameServerId/shop.categories.$categoryId.update'
import { Route as AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateImport } from './routes/_auth/gameserver.$gameServerId/modules.$moduleId.$moduleVersionTag.update'
import { Route as AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexImport } from './routes/_auth/gameserver.$gameServerId/modules.$moduleId.$moduleVersionTag.install.index'
import { Route as AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewImport } from './routes/_auth/gameserver.$gameServerId/modules.$moduleId.$moduleVersionTag.install.view'

// Create/Update Routes

const LogoutReturnRoute = LogoutReturnImport.update({
  id: '/logout-return',
  path: '/logout-return',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const ForbiddenRoute = ForbiddenImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRoute,
} as any)

const SinglePageRoute = SinglePageImport.update({
  id: '/_single-page',
  getParentRoute: () => rootRoute,
} as any)

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any)

const SinglePageLinkRoute = SinglePageLinkImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => SinglePageRoute,
} as any)

const AuthLogoutRoute = AuthLogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any)

const AuthPlayerRoute = AuthPlayerImport.update({
  id: '/_player',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGlobalRoute = AuthGlobalImport.update({
  id: '/_global',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGlobalIndexRoute = AuthGlobalIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const SinglePageAccountVerificationRoute =
  SinglePageAccountVerificationImport.update({
    id: '/account/verification',
    path: '/account/verification',
    getParentRoute: () => SinglePageRoute,
  } as any)

const SinglePageAccountRecoveryRoute = SinglePageAccountRecoveryImport.update({
  id: '/account/recovery',
  path: '/account/recovery',
  getParentRoute: () => SinglePageRoute,
} as any)

const SinglePageAccountProfileRoute = SinglePageAccountProfileImport.update({
  id: '/account/profile',
  path: '/account/profile',
  getParentRoute: () => SinglePageRoute,
} as any)

const AuthGameserverGameServerIdRoute = AuthGameserverGameServerIdImport.update(
  {
    id: '/gameserver/$gameServerId',
    path: '/gameserver/$gameServerId',
    getParentRoute: () => AuthRoute,
  } as any,
)

const AuthDomainSelectRoute = AuthDomainSelectImport.update({
  id: '/domain/select',
  path: '/domain/select',
  getParentRoute: () => AuthRoute,
} as any)

const AuthDomainDisabledRoute = AuthDomainDisabledImport.update({
  id: '/domain/disabled',
  path: '/domain/disabled',
  getParentRoute: () => AuthRoute,
} as any)

const AuthGlobalVariablesRoute = AuthGlobalVariablesImport.update({
  id: '/variables',
  path: '/variables',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalUsersRoute = AuthGlobalUsersImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalSettingsRoute = AuthGlobalSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalRolesRoute = AuthGlobalRolesImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalPlayersRoute = AuthGlobalPlayersImport.update({
  id: '/players',
  path: '/players',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalModulesRoute = AuthGlobalModulesImport.update({
  id: '/modules',
  path: '/modules',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalGameserversRoute = AuthGlobalGameserversImport.update({
  id: '/gameservers',
  path: '/gameservers',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalEventsRoute = AuthGlobalEventsImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalDashboardRoute = AuthGlobalDashboardImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalAnalyticsRoute = AuthGlobalAnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthModuleBuilderModuleIdIndexRoute =
  AuthModuleBuilderModuleIdIndexImport.update({
    id: '/module-builder/$moduleId/',
    path: '/module-builder/$moduleId/',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGlobalSettingsIndexRoute = AuthGlobalSettingsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthGlobalSettingsRoute,
} as any)

const AuthGlobalAnalyticsIndexRoute = AuthGlobalAnalyticsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthGlobalAnalyticsRoute,
} as any)

const AuthModuleBuilderModuleIdModuleVersionTagRoute =
  AuthModuleBuilderModuleIdModuleVersionTagImport.update({
    id: '/module-builder/$moduleId/$moduleVersionTag',
    path: '/module-builder/$moduleId/$moduleVersionTag',
    getParentRoute: () => AuthRoute,
  } as any)

const AuthGameserverGameServerIdShopRoute =
  AuthGameserverGameServerIdShopImport.update({
    id: '/shop',
    path: '/shop',
    getParentRoute: () => AuthGameserverGameServerIdRoute,
  } as any)

const AuthGameserverGameServerIdSettingsRoute =
  AuthGameserverGameServerIdSettingsImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthGameserverGameServerIdRoute,
  } as any)

const AuthGameserverGameServerIdModulesRoute =
  AuthGameserverGameServerIdModulesImport.update({
    id: '/modules',
    path: '/modules',
    getParentRoute: () => AuthGameserverGameServerIdRoute,
  } as any)

const AuthGameserverGameServerIdItemsRoute =
  AuthGameserverGameServerIdItemsImport.update({
    id: '/items',
    path: '/items',
    getParentRoute: () => AuthGameserverGameServerIdRoute,
  } as any)

const AuthGameserverGameServerIdDashboardRoute =
  AuthGameserverGameServerIdDashboardImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => AuthGameserverGameServerIdRoute,
  } as any)

const AuthPlayerShopGameServerIdRoute = AuthPlayerShopGameServerIdImport.update(
  {
    id: '/shop/$gameServerId',
    path: '/shop/$gameServerId',
    getParentRoute: () => AuthPlayerRoute,
  } as any,
)

const AuthGlobalVariablesCreateRoute = AuthGlobalVariablesCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthGlobalVariablesRoute,
} as any)

const AuthGlobalUserUserIdRoute = AuthGlobalUserUserIdImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalSettingsGameserversRoute =
  AuthGlobalSettingsGameserversImport.update({
    id: '/gameservers',
    path: '/gameservers',
    getParentRoute: () => AuthGlobalSettingsRoute,
  } as any)

const AuthGlobalSettingsDiscordRoute = AuthGlobalSettingsDiscordImport.update({
  id: '/discord',
  path: '/discord',
  getParentRoute: () => AuthGlobalSettingsRoute,
} as any)

const AuthGlobalRolesCreateRoute = AuthGlobalRolesCreateImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthGlobalRolesRoute,
} as any)

const AuthGlobalPlayerPlayerIdRoute = AuthGlobalPlayerPlayerIdImport.update({
  id: '/player/$playerId',
  path: '/player/$playerId',
  getParentRoute: () => AuthGlobalRoute,
} as any)

const AuthGlobalAnalyticsShopRoute = AuthGlobalAnalyticsShopImport.update({
  id: '/shop',
  path: '/shop',
  getParentRoute: () => AuthGlobalAnalyticsRoute,
} as any)

const AuthGameserverGameServerIdShopIndexRoute =
  AuthGameserverGameServerIdShopIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthPlayerShopGameServerIdIndexRoute =
  AuthPlayerShopGameServerIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthPlayerShopGameServerIdRoute,
  } as any)

const AuthGlobalSettingsBillingIndexRoute =
  AuthGlobalSettingsBillingIndexImport.update({
    id: '/billing/',
    path: '/billing/',
    getParentRoute: () => AuthGlobalSettingsRoute,
  } as any)

const AuthGlobalPlayerPlayerIdIndexRoute =
  AuthGlobalPlayerPlayerIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthGlobalPlayerPlayerIdRoute,
  } as any)

const AuthGlobalModulesCreateIndexRoute =
  AuthGlobalModulesCreateIndexImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthGlobalModulesRoute,
  } as any)

const AuthGlobalGameserversCreateIndexRoute =
  AuthGlobalGameserversCreateIndexImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => AuthGlobalGameserversRoute,
  } as any)

const AuthGameserverGameServerIdShopOrdersRoute =
  AuthGameserverGameServerIdShopOrdersImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdShopCategoriesRoute =
  AuthGameserverGameServerIdShopCategoriesImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdDashboardStatisticsRoute =
  AuthGameserverGameServerIdDashboardStatisticsImport.update({
    id: '/statistics',
    path: '/statistics',
    getParentRoute: () => AuthGameserverGameServerIdDashboardRoute,
  } as any)

const AuthGameserverGameServerIdDashboardPlayersRoute =
  AuthGameserverGameServerIdDashboardPlayersImport.update({
    id: '/players',
    path: '/players',
    getParentRoute: () => AuthGameserverGameServerIdDashboardRoute,
  } as any)

const AuthGameserverGameServerIdDashboardOverviewRoute =
  AuthGameserverGameServerIdDashboardOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => AuthGameserverGameServerIdDashboardRoute,
  } as any)

const AuthGameserverGameServerIdDashboardConsoleRoute =
  AuthGameserverGameServerIdDashboardConsoleImport.update({
    id: '/console',
    path: '/console',
    getParentRoute: () => AuthGameserverGameServerIdDashboardRoute,
  } as any)

const AuthPlayerShopGameServerIdOrdersRoute =
  AuthPlayerShopGameServerIdOrdersImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthPlayerShopGameServerIdRoute,
  } as any)

const AuthGlobalVariablesViewVariableIdRoute =
  AuthGlobalVariablesViewVariableIdImport.update({
    id: '/view/$variableId',
    path: '/view/$variableId',
    getParentRoute: () => AuthGlobalVariablesRoute,
  } as any)

const AuthGlobalVariablesUpdateVariableIdRoute =
  AuthGlobalVariablesUpdateVariableIdImport.update({
    id: '/update/$variableId',
    path: '/update/$variableId',
    getParentRoute: () => AuthGlobalVariablesRoute,
  } as any)

const AuthGlobalRolesViewRoleIdRoute = AuthGlobalRolesViewRoleIdImport.update({
  id: '/view/$roleId',
  path: '/view/$roleId',
  getParentRoute: () => AuthGlobalRolesRoute,
} as any)

const AuthGlobalRolesUpdateRoleIdRoute =
  AuthGlobalRolesUpdateRoleIdImport.update({
    id: '/update/$roleId',
    path: '/update/$roleId',
    getParentRoute: () => AuthGlobalRolesRoute,
  } as any)

const AuthGlobalPlayerPlayerIdInventoryRoute =
  AuthGlobalPlayerPlayerIdInventoryImport.update({
    id: '/inventory',
    path: '/inventory',
    getParentRoute: () => AuthGlobalPlayerPlayerIdRoute,
  } as any)

const AuthGlobalPlayerPlayerIdInfoRoute =
  AuthGlobalPlayerPlayerIdInfoImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => AuthGlobalPlayerPlayerIdRoute,
  } as any)

const AuthGlobalPlayerPlayerIdEventsRoute =
  AuthGlobalPlayerPlayerIdEventsImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => AuthGlobalPlayerPlayerIdRoute,
  } as any)

const AuthGlobalPlayerPlayerIdEconomyRoute =
  AuthGlobalPlayerPlayerIdEconomyImport.update({
    id: '/economy',
    path: '/economy',
    getParentRoute: () => AuthGlobalPlayerPlayerIdRoute,
  } as any)

const AuthGlobalModulesCreateImportRoute =
  AuthGlobalModulesCreateImportImport.update({
    id: '/create/import',
    path: '/create/import',
    getParentRoute: () => AuthGlobalModulesRoute,
  } as any)

const AuthGlobalModulesModuleIdUpdateRoute =
  AuthGlobalModulesModuleIdUpdateImport.update({
    id: '/$moduleId/update',
    path: '/$moduleId/update',
    getParentRoute: () => AuthGlobalModulesRoute,
  } as any)

const AuthGlobalGameserversUpdateGameServerIdRoute =
  AuthGlobalGameserversUpdateGameServerIdImport.update({
    id: '/update/$gameServerId',
    path: '/update/$gameServerId',
    getParentRoute: () => AuthGlobalGameserversRoute,
  } as any)

const AuthGlobalGameserversCreateImportRoute =
  AuthGlobalGameserversCreateImportImport.update({
    id: '/create/import',
    path: '/create/import',
    getParentRoute: () => AuthGlobalGameserversRoute,
  } as any)

const AuthGlobalModulesModuleIdViewIndexRoute =
  AuthGlobalModulesModuleIdViewIndexImport.update({
    id: '/$moduleId/view/',
    path: '/$moduleId/view/',
    getParentRoute: () => AuthGlobalModulesRoute,
  } as any)

const AuthGameserverGameServerIdShopListingCreateRoute =
  AuthGameserverGameServerIdShopListingCreateImport.update({
    id: '/listing/create',
    path: '/listing/create',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdShopCategoriesCreateRoute =
  AuthGameserverGameServerIdShopCategoriesCreateImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthGameserverGameServerIdShopCategoriesRoute,
  } as any)

const AuthGlobalUserUserIdRoleAssignRoute =
  AuthGlobalUserUserIdRoleAssignImport.update({
    id: '/role/assign',
    path: '/role/assign',
    getParentRoute: () => AuthGlobalUserUserIdRoute,
  } as any)

const AuthGlobalPlayerPlayerIdRoleAssignRoute =
  AuthGlobalPlayerPlayerIdRoleAssignImport.update({
    id: '/role/assign',
    path: '/role/assign',
    getParentRoute: () => AuthGlobalPlayerPlayerIdRoute,
  } as any)

const AuthGlobalModulesModuleIdViewModuleVersionTagRoute =
  AuthGlobalModulesModuleIdViewModuleVersionTagImport.update({
    id: '/$moduleId/view/$moduleVersionTag',
    path: '/$moduleId/view/$moduleVersionTag',
    getParentRoute: () => AuthGlobalModulesRoute,
  } as any)

const AuthGameserverGameServerIdShopListingImportGameserverRoute =
  AuthGameserverGameServerIdShopListingImportGameserverImport.update({
    id: '/listing/import/gameserver',
    path: '/listing/import/gameserver',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdShopListingImportFileRoute =
  AuthGameserverGameServerIdShopListingImportFileImport.update({
    id: '/listing/import/file',
    path: '/listing/import/file',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdShopListingShopListingIdViewRoute =
  AuthGameserverGameServerIdShopListingShopListingIdViewImport.update({
    id: '/listing/$shopListingId/view',
    path: '/listing/$shopListingId/view',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute =
  AuthGameserverGameServerIdShopListingShopListingIdUpdateImport.update({
    id: '/listing/$shopListingId/update',
    path: '/listing/$shopListingId/update',
    getParentRoute: () => AuthGameserverGameServerIdShopRoute,
  } as any)

const AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute =
  AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateImport.update({
    id: '/$categoryId/update',
    path: '/$categoryId/update',
    getParentRoute: () => AuthGameserverGameServerIdShopCategoriesRoute,
  } as any)

const AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute =
  AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateImport.update({
    id: '/$moduleId/$moduleVersionTag/update',
    path: '/$moduleId/$moduleVersionTag/update',
    getParentRoute: () => AuthGameserverGameServerIdModulesRoute,
  } as any)

const AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute =
  AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexImport.update(
    {
      id: '/$moduleId/$moduleVersionTag/install/',
      path: '/$moduleId/$moduleVersionTag/install/',
      getParentRoute: () => AuthGameserverGameServerIdModulesRoute,
    } as any,
  )

const AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute =
  AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewImport.update(
    {
      id: '/$moduleId/$moduleVersionTag/install/view',
      path: '/$moduleId/$moduleVersionTag/install/view',
      getParentRoute: () => AuthGameserverGameServerIdModulesRoute,
    } as any,
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthImport
      parentRoute: typeof rootRoute
    }
    '/_single-page': {
      id: '/_single-page'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof SinglePageImport
      parentRoute: typeof rootRoute
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/logout-return': {
      id: '/logout-return'
      path: '/logout-return'
      fullPath: '/logout-return'
      preLoaderRoute: typeof LogoutReturnImport
      parentRoute: typeof rootRoute
    }
    '/_auth/_global': {
      id: '/_auth/_global'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthGlobalImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_player': {
      id: '/_auth/_player'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthPlayerImport
      parentRoute: typeof AuthImport
    }
    '/_auth/logout': {
      id: '/_auth/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof AuthLogoutImport
      parentRoute: typeof AuthImport
    }
    '/_single-page/link': {
      id: '/_single-page/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof SinglePageLinkImport
      parentRoute: typeof SinglePageImport
    }
    '/_auth/_global/analytics': {
      id: '/_auth/_global/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthGlobalAnalyticsImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/dashboard': {
      id: '/_auth/_global/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthGlobalDashboardImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/events': {
      id: '/_auth/_global/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AuthGlobalEventsImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/gameservers': {
      id: '/_auth/_global/gameservers'
      path: '/gameservers'
      fullPath: '/gameservers'
      preLoaderRoute: typeof AuthGlobalGameserversImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/modules': {
      id: '/_auth/_global/modules'
      path: '/modules'
      fullPath: '/modules'
      preLoaderRoute: typeof AuthGlobalModulesImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/players': {
      id: '/_auth/_global/players'
      path: '/players'
      fullPath: '/players'
      preLoaderRoute: typeof AuthGlobalPlayersImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/roles': {
      id: '/_auth/_global/roles'
      path: '/roles'
      fullPath: '/roles'
      preLoaderRoute: typeof AuthGlobalRolesImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/settings': {
      id: '/_auth/_global/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthGlobalSettingsImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/users': {
      id: '/_auth/_global/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthGlobalUsersImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/variables': {
      id: '/_auth/_global/variables'
      path: '/variables'
      fullPath: '/variables'
      preLoaderRoute: typeof AuthGlobalVariablesImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/domain/disabled': {
      id: '/_auth/domain/disabled'
      path: '/domain/disabled'
      fullPath: '/domain/disabled'
      preLoaderRoute: typeof AuthDomainDisabledImport
      parentRoute: typeof AuthImport
    }
    '/_auth/domain/select': {
      id: '/_auth/domain/select'
      path: '/domain/select'
      fullPath: '/domain/select'
      preLoaderRoute: typeof AuthDomainSelectImport
      parentRoute: typeof AuthImport
    }
    '/_auth/gameserver/$gameServerId': {
      id: '/_auth/gameserver/$gameServerId'
      path: '/gameserver/$gameServerId'
      fullPath: '/gameserver/$gameServerId'
      preLoaderRoute: typeof AuthGameserverGameServerIdImport
      parentRoute: typeof AuthImport
    }
    '/_single-page/account/profile': {
      id: '/_single-page/account/profile'
      path: '/account/profile'
      fullPath: '/account/profile'
      preLoaderRoute: typeof SinglePageAccountProfileImport
      parentRoute: typeof SinglePageImport
    }
    '/_single-page/account/recovery': {
      id: '/_single-page/account/recovery'
      path: '/account/recovery'
      fullPath: '/account/recovery'
      preLoaderRoute: typeof SinglePageAccountRecoveryImport
      parentRoute: typeof SinglePageImport
    }
    '/_single-page/account/verification': {
      id: '/_single-page/account/verification'
      path: '/account/verification'
      fullPath: '/account/verification'
      preLoaderRoute: typeof SinglePageAccountVerificationImport
      parentRoute: typeof SinglePageImport
    }
    '/_auth/_global/': {
      id: '/_auth/_global/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthGlobalIndexImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/analytics/shop': {
      id: '/_auth/_global/analytics/shop'
      path: '/shop'
      fullPath: '/analytics/shop'
      preLoaderRoute: typeof AuthGlobalAnalyticsShopImport
      parentRoute: typeof AuthGlobalAnalyticsImport
    }
    '/_auth/_global/player/$playerId': {
      id: '/_auth/_global/player/$playerId'
      path: '/player/$playerId'
      fullPath: '/player/$playerId'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/roles/create': {
      id: '/_auth/_global/roles/create'
      path: '/create'
      fullPath: '/roles/create'
      preLoaderRoute: typeof AuthGlobalRolesCreateImport
      parentRoute: typeof AuthGlobalRolesImport
    }
    '/_auth/_global/settings/discord': {
      id: '/_auth/_global/settings/discord'
      path: '/discord'
      fullPath: '/settings/discord'
      preLoaderRoute: typeof AuthGlobalSettingsDiscordImport
      parentRoute: typeof AuthGlobalSettingsImport
    }
    '/_auth/_global/settings/gameservers': {
      id: '/_auth/_global/settings/gameservers'
      path: '/gameservers'
      fullPath: '/settings/gameservers'
      preLoaderRoute: typeof AuthGlobalSettingsGameserversImport
      parentRoute: typeof AuthGlobalSettingsImport
    }
    '/_auth/_global/user/$userId': {
      id: '/_auth/_global/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AuthGlobalUserUserIdImport
      parentRoute: typeof AuthGlobalImport
    }
    '/_auth/_global/variables/create': {
      id: '/_auth/_global/variables/create'
      path: '/create'
      fullPath: '/variables/create'
      preLoaderRoute: typeof AuthGlobalVariablesCreateImport
      parentRoute: typeof AuthGlobalVariablesImport
    }
    '/_auth/_player/shop/$gameServerId': {
      id: '/_auth/_player/shop/$gameServerId'
      path: '/shop/$gameServerId'
      fullPath: '/shop/$gameServerId'
      preLoaderRoute: typeof AuthPlayerShopGameServerIdImport
      parentRoute: typeof AuthPlayerImport
    }
    '/_auth/gameserver/$gameServerId/dashboard': {
      id: '/_auth/gameserver/$gameServerId/dashboard'
      path: '/dashboard'
      fullPath: '/gameserver/$gameServerId/dashboard'
      preLoaderRoute: typeof AuthGameserverGameServerIdDashboardImport
      parentRoute: typeof AuthGameserverGameServerIdImport
    }
    '/_auth/gameserver/$gameServerId/items': {
      id: '/_auth/gameserver/$gameServerId/items'
      path: '/items'
      fullPath: '/gameserver/$gameServerId/items'
      preLoaderRoute: typeof AuthGameserverGameServerIdItemsImport
      parentRoute: typeof AuthGameserverGameServerIdImport
    }
    '/_auth/gameserver/$gameServerId/modules': {
      id: '/_auth/gameserver/$gameServerId/modules'
      path: '/modules'
      fullPath: '/gameserver/$gameServerId/modules'
      preLoaderRoute: typeof AuthGameserverGameServerIdModulesImport
      parentRoute: typeof AuthGameserverGameServerIdImport
    }
    '/_auth/gameserver/$gameServerId/settings': {
      id: '/_auth/gameserver/$gameServerId/settings'
      path: '/settings'
      fullPath: '/gameserver/$gameServerId/settings'
      preLoaderRoute: typeof AuthGameserverGameServerIdSettingsImport
      parentRoute: typeof AuthGameserverGameServerIdImport
    }
    '/_auth/gameserver/$gameServerId/shop': {
      id: '/_auth/gameserver/$gameServerId/shop'
      path: '/shop'
      fullPath: '/gameserver/$gameServerId/shop'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopImport
      parentRoute: typeof AuthGameserverGameServerIdImport
    }
    '/_auth/module-builder/$moduleId/$moduleVersionTag': {
      id: '/_auth/module-builder/$moduleId/$moduleVersionTag'
      path: '/module-builder/$moduleId/$moduleVersionTag'
      fullPath: '/module-builder/$moduleId/$moduleVersionTag'
      preLoaderRoute: typeof AuthModuleBuilderModuleIdModuleVersionTagImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_global/analytics/': {
      id: '/_auth/_global/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthGlobalAnalyticsIndexImport
      parentRoute: typeof AuthGlobalAnalyticsImport
    }
    '/_auth/_global/settings/': {
      id: '/_auth/_global/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthGlobalSettingsIndexImport
      parentRoute: typeof AuthGlobalSettingsImport
    }
    '/_auth/module-builder/$moduleId/': {
      id: '/_auth/module-builder/$moduleId/'
      path: '/module-builder/$moduleId'
      fullPath: '/module-builder/$moduleId'
      preLoaderRoute: typeof AuthModuleBuilderModuleIdIndexImport
      parentRoute: typeof AuthImport
    }
    '/_auth/_global/gameservers/create/import': {
      id: '/_auth/_global/gameservers/create/import'
      path: '/create/import'
      fullPath: '/gameservers/create/import'
      preLoaderRoute: typeof AuthGlobalGameserversCreateImportImport
      parentRoute: typeof AuthGlobalGameserversImport
    }
    '/_auth/_global/gameservers/update/$gameServerId': {
      id: '/_auth/_global/gameservers/update/$gameServerId'
      path: '/update/$gameServerId'
      fullPath: '/gameservers/update/$gameServerId'
      preLoaderRoute: typeof AuthGlobalGameserversUpdateGameServerIdImport
      parentRoute: typeof AuthGlobalGameserversImport
    }
    '/_auth/_global/modules/$moduleId/update': {
      id: '/_auth/_global/modules/$moduleId/update'
      path: '/$moduleId/update'
      fullPath: '/modules/$moduleId/update'
      preLoaderRoute: typeof AuthGlobalModulesModuleIdUpdateImport
      parentRoute: typeof AuthGlobalModulesImport
    }
    '/_auth/_global/modules/create/import': {
      id: '/_auth/_global/modules/create/import'
      path: '/create/import'
      fullPath: '/modules/create/import'
      preLoaderRoute: typeof AuthGlobalModulesCreateImportImport
      parentRoute: typeof AuthGlobalModulesImport
    }
    '/_auth/_global/player/$playerId/economy': {
      id: '/_auth/_global/player/$playerId/economy'
      path: '/economy'
      fullPath: '/player/$playerId/economy'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdEconomyImport
      parentRoute: typeof AuthGlobalPlayerPlayerIdImport
    }
    '/_auth/_global/player/$playerId/events': {
      id: '/_auth/_global/player/$playerId/events'
      path: '/events'
      fullPath: '/player/$playerId/events'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdEventsImport
      parentRoute: typeof AuthGlobalPlayerPlayerIdImport
    }
    '/_auth/_global/player/$playerId/info': {
      id: '/_auth/_global/player/$playerId/info'
      path: '/info'
      fullPath: '/player/$playerId/info'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdInfoImport
      parentRoute: typeof AuthGlobalPlayerPlayerIdImport
    }
    '/_auth/_global/player/$playerId/inventory': {
      id: '/_auth/_global/player/$playerId/inventory'
      path: '/inventory'
      fullPath: '/player/$playerId/inventory'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdInventoryImport
      parentRoute: typeof AuthGlobalPlayerPlayerIdImport
    }
    '/_auth/_global/roles/update/$roleId': {
      id: '/_auth/_global/roles/update/$roleId'
      path: '/update/$roleId'
      fullPath: '/roles/update/$roleId'
      preLoaderRoute: typeof AuthGlobalRolesUpdateRoleIdImport
      parentRoute: typeof AuthGlobalRolesImport
    }
    '/_auth/_global/roles/view/$roleId': {
      id: '/_auth/_global/roles/view/$roleId'
      path: '/view/$roleId'
      fullPath: '/roles/view/$roleId'
      preLoaderRoute: typeof AuthGlobalRolesViewRoleIdImport
      parentRoute: typeof AuthGlobalRolesImport
    }
    '/_auth/_global/variables/update/$variableId': {
      id: '/_auth/_global/variables/update/$variableId'
      path: '/update/$variableId'
      fullPath: '/variables/update/$variableId'
      preLoaderRoute: typeof AuthGlobalVariablesUpdateVariableIdImport
      parentRoute: typeof AuthGlobalVariablesImport
    }
    '/_auth/_global/variables/view/$variableId': {
      id: '/_auth/_global/variables/view/$variableId'
      path: '/view/$variableId'
      fullPath: '/variables/view/$variableId'
      preLoaderRoute: typeof AuthGlobalVariablesViewVariableIdImport
      parentRoute: typeof AuthGlobalVariablesImport
    }
    '/_auth/_player/shop/$gameServerId/orders': {
      id: '/_auth/_player/shop/$gameServerId/orders'
      path: '/orders'
      fullPath: '/shop/$gameServerId/orders'
      preLoaderRoute: typeof AuthPlayerShopGameServerIdOrdersImport
      parentRoute: typeof AuthPlayerShopGameServerIdImport
    }
    '/_auth/gameserver/$gameServerId/dashboard/console': {
      id: '/_auth/gameserver/$gameServerId/dashboard/console'
      path: '/console'
      fullPath: '/gameserver/$gameServerId/dashboard/console'
      preLoaderRoute: typeof AuthGameserverGameServerIdDashboardConsoleImport
      parentRoute: typeof AuthGameserverGameServerIdDashboardImport
    }
    '/_auth/gameserver/$gameServerId/dashboard/overview': {
      id: '/_auth/gameserver/$gameServerId/dashboard/overview'
      path: '/overview'
      fullPath: '/gameserver/$gameServerId/dashboard/overview'
      preLoaderRoute: typeof AuthGameserverGameServerIdDashboardOverviewImport
      parentRoute: typeof AuthGameserverGameServerIdDashboardImport
    }
    '/_auth/gameserver/$gameServerId/dashboard/players': {
      id: '/_auth/gameserver/$gameServerId/dashboard/players'
      path: '/players'
      fullPath: '/gameserver/$gameServerId/dashboard/players'
      preLoaderRoute: typeof AuthGameserverGameServerIdDashboardPlayersImport
      parentRoute: typeof AuthGameserverGameServerIdDashboardImport
    }
    '/_auth/gameserver/$gameServerId/dashboard/statistics': {
      id: '/_auth/gameserver/$gameServerId/dashboard/statistics'
      path: '/statistics'
      fullPath: '/gameserver/$gameServerId/dashboard/statistics'
      preLoaderRoute: typeof AuthGameserverGameServerIdDashboardStatisticsImport
      parentRoute: typeof AuthGameserverGameServerIdDashboardImport
    }
    '/_auth/gameserver/$gameServerId/shop/categories': {
      id: '/_auth/gameserver/$gameServerId/shop/categories'
      path: '/categories'
      fullPath: '/gameserver/$gameServerId/shop/categories'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopCategoriesImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/gameserver/$gameServerId/shop/orders': {
      id: '/_auth/gameserver/$gameServerId/shop/orders'
      path: '/orders'
      fullPath: '/gameserver/$gameServerId/shop/orders'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopOrdersImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/_global/gameservers/create/': {
      id: '/_auth/_global/gameservers/create/'
      path: '/create'
      fullPath: '/gameservers/create'
      preLoaderRoute: typeof AuthGlobalGameserversCreateIndexImport
      parentRoute: typeof AuthGlobalGameserversImport
    }
    '/_auth/_global/modules/create/': {
      id: '/_auth/_global/modules/create/'
      path: '/create'
      fullPath: '/modules/create'
      preLoaderRoute: typeof AuthGlobalModulesCreateIndexImport
      parentRoute: typeof AuthGlobalModulesImport
    }
    '/_auth/_global/player/$playerId/': {
      id: '/_auth/_global/player/$playerId/'
      path: '/'
      fullPath: '/player/$playerId/'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdIndexImport
      parentRoute: typeof AuthGlobalPlayerPlayerIdImport
    }
    '/_auth/_global/settings/billing/': {
      id: '/_auth/_global/settings/billing/'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AuthGlobalSettingsBillingIndexImport
      parentRoute: typeof AuthGlobalSettingsImport
    }
    '/_auth/_player/shop/$gameServerId/': {
      id: '/_auth/_player/shop/$gameServerId/'
      path: '/'
      fullPath: '/shop/$gameServerId/'
      preLoaderRoute: typeof AuthPlayerShopGameServerIdIndexImport
      parentRoute: typeof AuthPlayerShopGameServerIdImport
    }
    '/_auth/gameserver/$gameServerId/shop/': {
      id: '/_auth/gameserver/$gameServerId/shop/'
      path: '/'
      fullPath: '/gameserver/$gameServerId/shop/'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopIndexImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/_global/modules/$moduleId/view/$moduleVersionTag': {
      id: '/_auth/_global/modules/$moduleId/view/$moduleVersionTag'
      path: '/$moduleId/view/$moduleVersionTag'
      fullPath: '/modules/$moduleId/view/$moduleVersionTag'
      preLoaderRoute: typeof AuthGlobalModulesModuleIdViewModuleVersionTagImport
      parentRoute: typeof AuthGlobalModulesImport
    }
    '/_auth/_global/player/$playerId/role/assign': {
      id: '/_auth/_global/player/$playerId/role/assign'
      path: '/role/assign'
      fullPath: '/player/$playerId/role/assign'
      preLoaderRoute: typeof AuthGlobalPlayerPlayerIdRoleAssignImport
      parentRoute: typeof AuthGlobalPlayerPlayerIdImport
    }
    '/_auth/_global/user/$userId/role/assign': {
      id: '/_auth/_global/user/$userId/role/assign'
      path: '/role/assign'
      fullPath: '/user/$userId/role/assign'
      preLoaderRoute: typeof AuthGlobalUserUserIdRoleAssignImport
      parentRoute: typeof AuthGlobalUserUserIdImport
    }
    '/_auth/gameserver/$gameServerId/shop/categories/create': {
      id: '/_auth/gameserver/$gameServerId/shop/categories/create'
      path: '/create'
      fullPath: '/gameserver/$gameServerId/shop/categories/create'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopCategoriesCreateImport
      parentRoute: typeof AuthGameserverGameServerIdShopCategoriesImport
    }
    '/_auth/gameserver/$gameServerId/shop/listing/create': {
      id: '/_auth/gameserver/$gameServerId/shop/listing/create'
      path: '/listing/create'
      fullPath: '/gameserver/$gameServerId/shop/listing/create'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopListingCreateImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/_global/modules/$moduleId/view/': {
      id: '/_auth/_global/modules/$moduleId/view/'
      path: '/$moduleId/view'
      fullPath: '/modules/$moduleId/view'
      preLoaderRoute: typeof AuthGlobalModulesModuleIdViewIndexImport
      parentRoute: typeof AuthGlobalModulesImport
    }
    '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update': {
      id: '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update'
      path: '/$moduleId/$moduleVersionTag/update'
      fullPath: '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update'
      preLoaderRoute: typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateImport
      parentRoute: typeof AuthGameserverGameServerIdModulesImport
    }
    '/_auth/gameserver/$gameServerId/shop/categories/$categoryId/update': {
      id: '/_auth/gameserver/$gameServerId/shop/categories/$categoryId/update'
      path: '/$categoryId/update'
      fullPath: '/gameserver/$gameServerId/shop/categories/$categoryId/update'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateImport
      parentRoute: typeof AuthGameserverGameServerIdShopCategoriesImport
    }
    '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/update': {
      id: '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/update'
      path: '/listing/$shopListingId/update'
      fullPath: '/gameserver/$gameServerId/shop/listing/$shopListingId/update'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopListingShopListingIdUpdateImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/view': {
      id: '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/view'
      path: '/listing/$shopListingId/view'
      fullPath: '/gameserver/$gameServerId/shop/listing/$shopListingId/view'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopListingShopListingIdViewImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/gameserver/$gameServerId/shop/listing/import/file': {
      id: '/_auth/gameserver/$gameServerId/shop/listing/import/file'
      path: '/listing/import/file'
      fullPath: '/gameserver/$gameServerId/shop/listing/import/file'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopListingImportFileImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/gameserver/$gameServerId/shop/listing/import/gameserver': {
      id: '/_auth/gameserver/$gameServerId/shop/listing/import/gameserver'
      path: '/listing/import/gameserver'
      fullPath: '/gameserver/$gameServerId/shop/listing/import/gameserver'
      preLoaderRoute: typeof AuthGameserverGameServerIdShopListingImportGameserverImport
      parentRoute: typeof AuthGameserverGameServerIdShopImport
    }
    '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view': {
      id: '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view'
      path: '/$moduleId/$moduleVersionTag/install/view'
      fullPath: '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view'
      preLoaderRoute: typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewImport
      parentRoute: typeof AuthGameserverGameServerIdModulesImport
    }
    '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/': {
      id: '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/'
      path: '/$moduleId/$moduleVersionTag/install'
      fullPath: '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install'
      preLoaderRoute: typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexImport
      parentRoute: typeof AuthGameserverGameServerIdModulesImport
    }
  }
}

// Create and export the route tree

interface AuthGlobalAnalyticsRouteChildren {
  AuthGlobalAnalyticsShopRoute: typeof AuthGlobalAnalyticsShopRoute
  AuthGlobalAnalyticsIndexRoute: typeof AuthGlobalAnalyticsIndexRoute
}

const AuthGlobalAnalyticsRouteChildren: AuthGlobalAnalyticsRouteChildren = {
  AuthGlobalAnalyticsShopRoute: AuthGlobalAnalyticsShopRoute,
  AuthGlobalAnalyticsIndexRoute: AuthGlobalAnalyticsIndexRoute,
}

const AuthGlobalAnalyticsRouteWithChildren =
  AuthGlobalAnalyticsRoute._addFileChildren(AuthGlobalAnalyticsRouteChildren)

interface AuthGlobalGameserversRouteChildren {
  AuthGlobalGameserversCreateImportRoute: typeof AuthGlobalGameserversCreateImportRoute
  AuthGlobalGameserversUpdateGameServerIdRoute: typeof AuthGlobalGameserversUpdateGameServerIdRoute
  AuthGlobalGameserversCreateIndexRoute: typeof AuthGlobalGameserversCreateIndexRoute
}

const AuthGlobalGameserversRouteChildren: AuthGlobalGameserversRouteChildren = {
  AuthGlobalGameserversCreateImportRoute:
    AuthGlobalGameserversCreateImportRoute,
  AuthGlobalGameserversUpdateGameServerIdRoute:
    AuthGlobalGameserversUpdateGameServerIdRoute,
  AuthGlobalGameserversCreateIndexRoute: AuthGlobalGameserversCreateIndexRoute,
}

const AuthGlobalGameserversRouteWithChildren =
  AuthGlobalGameserversRoute._addFileChildren(
    AuthGlobalGameserversRouteChildren,
  )

interface AuthGlobalModulesRouteChildren {
  AuthGlobalModulesModuleIdUpdateRoute: typeof AuthGlobalModulesModuleIdUpdateRoute
  AuthGlobalModulesCreateImportRoute: typeof AuthGlobalModulesCreateImportRoute
  AuthGlobalModulesCreateIndexRoute: typeof AuthGlobalModulesCreateIndexRoute
  AuthGlobalModulesModuleIdViewModuleVersionTagRoute: typeof AuthGlobalModulesModuleIdViewModuleVersionTagRoute
  AuthGlobalModulesModuleIdViewIndexRoute: typeof AuthGlobalModulesModuleIdViewIndexRoute
}

const AuthGlobalModulesRouteChildren: AuthGlobalModulesRouteChildren = {
  AuthGlobalModulesModuleIdUpdateRoute: AuthGlobalModulesModuleIdUpdateRoute,
  AuthGlobalModulesCreateImportRoute: AuthGlobalModulesCreateImportRoute,
  AuthGlobalModulesCreateIndexRoute: AuthGlobalModulesCreateIndexRoute,
  AuthGlobalModulesModuleIdViewModuleVersionTagRoute:
    AuthGlobalModulesModuleIdViewModuleVersionTagRoute,
  AuthGlobalModulesModuleIdViewIndexRoute:
    AuthGlobalModulesModuleIdViewIndexRoute,
}

const AuthGlobalModulesRouteWithChildren =
  AuthGlobalModulesRoute._addFileChildren(AuthGlobalModulesRouteChildren)

interface AuthGlobalRolesRouteChildren {
  AuthGlobalRolesCreateRoute: typeof AuthGlobalRolesCreateRoute
  AuthGlobalRolesUpdateRoleIdRoute: typeof AuthGlobalRolesUpdateRoleIdRoute
  AuthGlobalRolesViewRoleIdRoute: typeof AuthGlobalRolesViewRoleIdRoute
}

const AuthGlobalRolesRouteChildren: AuthGlobalRolesRouteChildren = {
  AuthGlobalRolesCreateRoute: AuthGlobalRolesCreateRoute,
  AuthGlobalRolesUpdateRoleIdRoute: AuthGlobalRolesUpdateRoleIdRoute,
  AuthGlobalRolesViewRoleIdRoute: AuthGlobalRolesViewRoleIdRoute,
}

const AuthGlobalRolesRouteWithChildren = AuthGlobalRolesRoute._addFileChildren(
  AuthGlobalRolesRouteChildren,
)

interface AuthGlobalSettingsRouteChildren {
  AuthGlobalSettingsDiscordRoute: typeof AuthGlobalSettingsDiscordRoute
  AuthGlobalSettingsGameserversRoute: typeof AuthGlobalSettingsGameserversRoute
  AuthGlobalSettingsIndexRoute: typeof AuthGlobalSettingsIndexRoute
  AuthGlobalSettingsBillingIndexRoute: typeof AuthGlobalSettingsBillingIndexRoute
}

const AuthGlobalSettingsRouteChildren: AuthGlobalSettingsRouteChildren = {
  AuthGlobalSettingsDiscordRoute: AuthGlobalSettingsDiscordRoute,
  AuthGlobalSettingsGameserversRoute: AuthGlobalSettingsGameserversRoute,
  AuthGlobalSettingsIndexRoute: AuthGlobalSettingsIndexRoute,
  AuthGlobalSettingsBillingIndexRoute: AuthGlobalSettingsBillingIndexRoute,
}

const AuthGlobalSettingsRouteWithChildren =
  AuthGlobalSettingsRoute._addFileChildren(AuthGlobalSettingsRouteChildren)

interface AuthGlobalVariablesRouteChildren {
  AuthGlobalVariablesCreateRoute: typeof AuthGlobalVariablesCreateRoute
  AuthGlobalVariablesUpdateVariableIdRoute: typeof AuthGlobalVariablesUpdateVariableIdRoute
  AuthGlobalVariablesViewVariableIdRoute: typeof AuthGlobalVariablesViewVariableIdRoute
}

const AuthGlobalVariablesRouteChildren: AuthGlobalVariablesRouteChildren = {
  AuthGlobalVariablesCreateRoute: AuthGlobalVariablesCreateRoute,
  AuthGlobalVariablesUpdateVariableIdRoute:
    AuthGlobalVariablesUpdateVariableIdRoute,
  AuthGlobalVariablesViewVariableIdRoute:
    AuthGlobalVariablesViewVariableIdRoute,
}

const AuthGlobalVariablesRouteWithChildren =
  AuthGlobalVariablesRoute._addFileChildren(AuthGlobalVariablesRouteChildren)

interface AuthGlobalPlayerPlayerIdRouteChildren {
  AuthGlobalPlayerPlayerIdEconomyRoute: typeof AuthGlobalPlayerPlayerIdEconomyRoute
  AuthGlobalPlayerPlayerIdEventsRoute: typeof AuthGlobalPlayerPlayerIdEventsRoute
  AuthGlobalPlayerPlayerIdInfoRoute: typeof AuthGlobalPlayerPlayerIdInfoRoute
  AuthGlobalPlayerPlayerIdInventoryRoute: typeof AuthGlobalPlayerPlayerIdInventoryRoute
  AuthGlobalPlayerPlayerIdIndexRoute: typeof AuthGlobalPlayerPlayerIdIndexRoute
  AuthGlobalPlayerPlayerIdRoleAssignRoute: typeof AuthGlobalPlayerPlayerIdRoleAssignRoute
}

const AuthGlobalPlayerPlayerIdRouteChildren: AuthGlobalPlayerPlayerIdRouteChildren =
  {
    AuthGlobalPlayerPlayerIdEconomyRoute: AuthGlobalPlayerPlayerIdEconomyRoute,
    AuthGlobalPlayerPlayerIdEventsRoute: AuthGlobalPlayerPlayerIdEventsRoute,
    AuthGlobalPlayerPlayerIdInfoRoute: AuthGlobalPlayerPlayerIdInfoRoute,
    AuthGlobalPlayerPlayerIdInventoryRoute:
      AuthGlobalPlayerPlayerIdInventoryRoute,
    AuthGlobalPlayerPlayerIdIndexRoute: AuthGlobalPlayerPlayerIdIndexRoute,
    AuthGlobalPlayerPlayerIdRoleAssignRoute:
      AuthGlobalPlayerPlayerIdRoleAssignRoute,
  }

const AuthGlobalPlayerPlayerIdRouteWithChildren =
  AuthGlobalPlayerPlayerIdRoute._addFileChildren(
    AuthGlobalPlayerPlayerIdRouteChildren,
  )

interface AuthGlobalUserUserIdRouteChildren {
  AuthGlobalUserUserIdRoleAssignRoute: typeof AuthGlobalUserUserIdRoleAssignRoute
}

const AuthGlobalUserUserIdRouteChildren: AuthGlobalUserUserIdRouteChildren = {
  AuthGlobalUserUserIdRoleAssignRoute: AuthGlobalUserUserIdRoleAssignRoute,
}

const AuthGlobalUserUserIdRouteWithChildren =
  AuthGlobalUserUserIdRoute._addFileChildren(AuthGlobalUserUserIdRouteChildren)

interface AuthGlobalRouteChildren {
  AuthGlobalAnalyticsRoute: typeof AuthGlobalAnalyticsRouteWithChildren
  AuthGlobalDashboardRoute: typeof AuthGlobalDashboardRoute
  AuthGlobalEventsRoute: typeof AuthGlobalEventsRoute
  AuthGlobalGameserversRoute: typeof AuthGlobalGameserversRouteWithChildren
  AuthGlobalModulesRoute: typeof AuthGlobalModulesRouteWithChildren
  AuthGlobalPlayersRoute: typeof AuthGlobalPlayersRoute
  AuthGlobalRolesRoute: typeof AuthGlobalRolesRouteWithChildren
  AuthGlobalSettingsRoute: typeof AuthGlobalSettingsRouteWithChildren
  AuthGlobalUsersRoute: typeof AuthGlobalUsersRoute
  AuthGlobalVariablesRoute: typeof AuthGlobalVariablesRouteWithChildren
  AuthGlobalIndexRoute: typeof AuthGlobalIndexRoute
  AuthGlobalPlayerPlayerIdRoute: typeof AuthGlobalPlayerPlayerIdRouteWithChildren
  AuthGlobalUserUserIdRoute: typeof AuthGlobalUserUserIdRouteWithChildren
}

const AuthGlobalRouteChildren: AuthGlobalRouteChildren = {
  AuthGlobalAnalyticsRoute: AuthGlobalAnalyticsRouteWithChildren,
  AuthGlobalDashboardRoute: AuthGlobalDashboardRoute,
  AuthGlobalEventsRoute: AuthGlobalEventsRoute,
  AuthGlobalGameserversRoute: AuthGlobalGameserversRouteWithChildren,
  AuthGlobalModulesRoute: AuthGlobalModulesRouteWithChildren,
  AuthGlobalPlayersRoute: AuthGlobalPlayersRoute,
  AuthGlobalRolesRoute: AuthGlobalRolesRouteWithChildren,
  AuthGlobalSettingsRoute: AuthGlobalSettingsRouteWithChildren,
  AuthGlobalUsersRoute: AuthGlobalUsersRoute,
  AuthGlobalVariablesRoute: AuthGlobalVariablesRouteWithChildren,
  AuthGlobalIndexRoute: AuthGlobalIndexRoute,
  AuthGlobalPlayerPlayerIdRoute: AuthGlobalPlayerPlayerIdRouteWithChildren,
  AuthGlobalUserUserIdRoute: AuthGlobalUserUserIdRouteWithChildren,
}

const AuthGlobalRouteWithChildren = AuthGlobalRoute._addFileChildren(
  AuthGlobalRouteChildren,
)

interface AuthPlayerShopGameServerIdRouteChildren {
  AuthPlayerShopGameServerIdOrdersRoute: typeof AuthPlayerShopGameServerIdOrdersRoute
  AuthPlayerShopGameServerIdIndexRoute: typeof AuthPlayerShopGameServerIdIndexRoute
}

const AuthPlayerShopGameServerIdRouteChildren: AuthPlayerShopGameServerIdRouteChildren =
  {
    AuthPlayerShopGameServerIdOrdersRoute:
      AuthPlayerShopGameServerIdOrdersRoute,
    AuthPlayerShopGameServerIdIndexRoute: AuthPlayerShopGameServerIdIndexRoute,
  }

const AuthPlayerShopGameServerIdRouteWithChildren =
  AuthPlayerShopGameServerIdRoute._addFileChildren(
    AuthPlayerShopGameServerIdRouteChildren,
  )

interface AuthPlayerRouteChildren {
  AuthPlayerShopGameServerIdRoute: typeof AuthPlayerShopGameServerIdRouteWithChildren
}

const AuthPlayerRouteChildren: AuthPlayerRouteChildren = {
  AuthPlayerShopGameServerIdRoute: AuthPlayerShopGameServerIdRouteWithChildren,
}

const AuthPlayerRouteWithChildren = AuthPlayerRoute._addFileChildren(
  AuthPlayerRouteChildren,
)

interface AuthGameserverGameServerIdDashboardRouteChildren {
  AuthGameserverGameServerIdDashboardConsoleRoute: typeof AuthGameserverGameServerIdDashboardConsoleRoute
  AuthGameserverGameServerIdDashboardOverviewRoute: typeof AuthGameserverGameServerIdDashboardOverviewRoute
  AuthGameserverGameServerIdDashboardPlayersRoute: typeof AuthGameserverGameServerIdDashboardPlayersRoute
  AuthGameserverGameServerIdDashboardStatisticsRoute: typeof AuthGameserverGameServerIdDashboardStatisticsRoute
}

const AuthGameserverGameServerIdDashboardRouteChildren: AuthGameserverGameServerIdDashboardRouteChildren =
  {
    AuthGameserverGameServerIdDashboardConsoleRoute:
      AuthGameserverGameServerIdDashboardConsoleRoute,
    AuthGameserverGameServerIdDashboardOverviewRoute:
      AuthGameserverGameServerIdDashboardOverviewRoute,
    AuthGameserverGameServerIdDashboardPlayersRoute:
      AuthGameserverGameServerIdDashboardPlayersRoute,
    AuthGameserverGameServerIdDashboardStatisticsRoute:
      AuthGameserverGameServerIdDashboardStatisticsRoute,
  }

const AuthGameserverGameServerIdDashboardRouteWithChildren =
  AuthGameserverGameServerIdDashboardRoute._addFileChildren(
    AuthGameserverGameServerIdDashboardRouteChildren,
  )

interface AuthGameserverGameServerIdModulesRouteChildren {
  AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute: typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute
  AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute: typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute
  AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute: typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute
}

const AuthGameserverGameServerIdModulesRouteChildren: AuthGameserverGameServerIdModulesRouteChildren =
  {
    AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute:
      AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute,
    AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute:
      AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute,
    AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute:
      AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute,
  }

const AuthGameserverGameServerIdModulesRouteWithChildren =
  AuthGameserverGameServerIdModulesRoute._addFileChildren(
    AuthGameserverGameServerIdModulesRouteChildren,
  )

interface AuthGameserverGameServerIdShopCategoriesRouteChildren {
  AuthGameserverGameServerIdShopCategoriesCreateRoute: typeof AuthGameserverGameServerIdShopCategoriesCreateRoute
  AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute: typeof AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute
}

const AuthGameserverGameServerIdShopCategoriesRouteChildren: AuthGameserverGameServerIdShopCategoriesRouteChildren =
  {
    AuthGameserverGameServerIdShopCategoriesCreateRoute:
      AuthGameserverGameServerIdShopCategoriesCreateRoute,
    AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute:
      AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute,
  }

const AuthGameserverGameServerIdShopCategoriesRouteWithChildren =
  AuthGameserverGameServerIdShopCategoriesRoute._addFileChildren(
    AuthGameserverGameServerIdShopCategoriesRouteChildren,
  )

interface AuthGameserverGameServerIdShopRouteChildren {
  AuthGameserverGameServerIdShopCategoriesRoute: typeof AuthGameserverGameServerIdShopCategoriesRouteWithChildren
  AuthGameserverGameServerIdShopOrdersRoute: typeof AuthGameserverGameServerIdShopOrdersRoute
  AuthGameserverGameServerIdShopIndexRoute: typeof AuthGameserverGameServerIdShopIndexRoute
  AuthGameserverGameServerIdShopListingCreateRoute: typeof AuthGameserverGameServerIdShopListingCreateRoute
  AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute: typeof AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute
  AuthGameserverGameServerIdShopListingShopListingIdViewRoute: typeof AuthGameserverGameServerIdShopListingShopListingIdViewRoute
  AuthGameserverGameServerIdShopListingImportFileRoute: typeof AuthGameserverGameServerIdShopListingImportFileRoute
  AuthGameserverGameServerIdShopListingImportGameserverRoute: typeof AuthGameserverGameServerIdShopListingImportGameserverRoute
}

const AuthGameserverGameServerIdShopRouteChildren: AuthGameserverGameServerIdShopRouteChildren =
  {
    AuthGameserverGameServerIdShopCategoriesRoute:
      AuthGameserverGameServerIdShopCategoriesRouteWithChildren,
    AuthGameserverGameServerIdShopOrdersRoute:
      AuthGameserverGameServerIdShopOrdersRoute,
    AuthGameserverGameServerIdShopIndexRoute:
      AuthGameserverGameServerIdShopIndexRoute,
    AuthGameserverGameServerIdShopListingCreateRoute:
      AuthGameserverGameServerIdShopListingCreateRoute,
    AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute:
      AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute,
    AuthGameserverGameServerIdShopListingShopListingIdViewRoute:
      AuthGameserverGameServerIdShopListingShopListingIdViewRoute,
    AuthGameserverGameServerIdShopListingImportFileRoute:
      AuthGameserverGameServerIdShopListingImportFileRoute,
    AuthGameserverGameServerIdShopListingImportGameserverRoute:
      AuthGameserverGameServerIdShopListingImportGameserverRoute,
  }

const AuthGameserverGameServerIdShopRouteWithChildren =
  AuthGameserverGameServerIdShopRoute._addFileChildren(
    AuthGameserverGameServerIdShopRouteChildren,
  )

interface AuthGameserverGameServerIdRouteChildren {
  AuthGameserverGameServerIdDashboardRoute: typeof AuthGameserverGameServerIdDashboardRouteWithChildren
  AuthGameserverGameServerIdItemsRoute: typeof AuthGameserverGameServerIdItemsRoute
  AuthGameserverGameServerIdModulesRoute: typeof AuthGameserverGameServerIdModulesRouteWithChildren
  AuthGameserverGameServerIdSettingsRoute: typeof AuthGameserverGameServerIdSettingsRoute
  AuthGameserverGameServerIdShopRoute: typeof AuthGameserverGameServerIdShopRouteWithChildren
}

const AuthGameserverGameServerIdRouteChildren: AuthGameserverGameServerIdRouteChildren =
  {
    AuthGameserverGameServerIdDashboardRoute:
      AuthGameserverGameServerIdDashboardRouteWithChildren,
    AuthGameserverGameServerIdItemsRoute: AuthGameserverGameServerIdItemsRoute,
    AuthGameserverGameServerIdModulesRoute:
      AuthGameserverGameServerIdModulesRouteWithChildren,
    AuthGameserverGameServerIdSettingsRoute:
      AuthGameserverGameServerIdSettingsRoute,
    AuthGameserverGameServerIdShopRoute:
      AuthGameserverGameServerIdShopRouteWithChildren,
  }

const AuthGameserverGameServerIdRouteWithChildren =
  AuthGameserverGameServerIdRoute._addFileChildren(
    AuthGameserverGameServerIdRouteChildren,
  )

interface AuthRouteChildren {
  AuthGlobalRoute: typeof AuthGlobalRouteWithChildren
  AuthPlayerRoute: typeof AuthPlayerRouteWithChildren
  AuthLogoutRoute: typeof AuthLogoutRoute
  AuthDomainDisabledRoute: typeof AuthDomainDisabledRoute
  AuthDomainSelectRoute: typeof AuthDomainSelectRoute
  AuthGameserverGameServerIdRoute: typeof AuthGameserverGameServerIdRouteWithChildren
  AuthModuleBuilderModuleIdModuleVersionTagRoute: typeof AuthModuleBuilderModuleIdModuleVersionTagRoute
  AuthModuleBuilderModuleIdIndexRoute: typeof AuthModuleBuilderModuleIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthGlobalRoute: AuthGlobalRouteWithChildren,
  AuthPlayerRoute: AuthPlayerRouteWithChildren,
  AuthLogoutRoute: AuthLogoutRoute,
  AuthDomainDisabledRoute: AuthDomainDisabledRoute,
  AuthDomainSelectRoute: AuthDomainSelectRoute,
  AuthGameserverGameServerIdRoute: AuthGameserverGameServerIdRouteWithChildren,
  AuthModuleBuilderModuleIdModuleVersionTagRoute:
    AuthModuleBuilderModuleIdModuleVersionTagRoute,
  AuthModuleBuilderModuleIdIndexRoute: AuthModuleBuilderModuleIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface SinglePageRouteChildren {
  SinglePageLinkRoute: typeof SinglePageLinkRoute
  SinglePageAccountProfileRoute: typeof SinglePageAccountProfileRoute
  SinglePageAccountRecoveryRoute: typeof SinglePageAccountRecoveryRoute
  SinglePageAccountVerificationRoute: typeof SinglePageAccountVerificationRoute
}

const SinglePageRouteChildren: SinglePageRouteChildren = {
  SinglePageLinkRoute: SinglePageLinkRoute,
  SinglePageAccountProfileRoute: SinglePageAccountProfileRoute,
  SinglePageAccountRecoveryRoute: SinglePageAccountRecoveryRoute,
  SinglePageAccountVerificationRoute: SinglePageAccountVerificationRoute,
}

const SinglePageRouteWithChildren = SinglePageRoute._addFileChildren(
  SinglePageRouteChildren,
)

export interface FileRoutesByFullPath {
  '': typeof AuthPlayerRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/logout-return': typeof LogoutReturnRoute
  '/logout': typeof AuthLogoutRoute
  '/link': typeof SinglePageLinkRoute
  '/analytics': typeof AuthGlobalAnalyticsRouteWithChildren
  '/dashboard': typeof AuthGlobalDashboardRoute
  '/events': typeof AuthGlobalEventsRoute
  '/gameservers': typeof AuthGlobalGameserversRouteWithChildren
  '/modules': typeof AuthGlobalModulesRouteWithChildren
  '/players': typeof AuthGlobalPlayersRoute
  '/roles': typeof AuthGlobalRolesRouteWithChildren
  '/settings': typeof AuthGlobalSettingsRouteWithChildren
  '/users': typeof AuthGlobalUsersRoute
  '/variables': typeof AuthGlobalVariablesRouteWithChildren
  '/domain/disabled': typeof AuthDomainDisabledRoute
  '/domain/select': typeof AuthDomainSelectRoute
  '/gameserver/$gameServerId': typeof AuthGameserverGameServerIdRouteWithChildren
  '/account/profile': typeof SinglePageAccountProfileRoute
  '/account/recovery': typeof SinglePageAccountRecoveryRoute
  '/account/verification': typeof SinglePageAccountVerificationRoute
  '/': typeof AuthGlobalIndexRoute
  '/analytics/shop': typeof AuthGlobalAnalyticsShopRoute
  '/player/$playerId': typeof AuthGlobalPlayerPlayerIdRouteWithChildren
  '/roles/create': typeof AuthGlobalRolesCreateRoute
  '/settings/discord': typeof AuthGlobalSettingsDiscordRoute
  '/settings/gameservers': typeof AuthGlobalSettingsGameserversRoute
  '/user/$userId': typeof AuthGlobalUserUserIdRouteWithChildren
  '/variables/create': typeof AuthGlobalVariablesCreateRoute
  '/shop/$gameServerId': typeof AuthPlayerShopGameServerIdRouteWithChildren
  '/gameserver/$gameServerId/dashboard': typeof AuthGameserverGameServerIdDashboardRouteWithChildren
  '/gameserver/$gameServerId/items': typeof AuthGameserverGameServerIdItemsRoute
  '/gameserver/$gameServerId/modules': typeof AuthGameserverGameServerIdModulesRouteWithChildren
  '/gameserver/$gameServerId/settings': typeof AuthGameserverGameServerIdSettingsRoute
  '/gameserver/$gameServerId/shop': typeof AuthGameserverGameServerIdShopRouteWithChildren
  '/module-builder/$moduleId/$moduleVersionTag': typeof AuthModuleBuilderModuleIdModuleVersionTagRoute
  '/analytics/': typeof AuthGlobalAnalyticsIndexRoute
  '/settings/': typeof AuthGlobalSettingsIndexRoute
  '/module-builder/$moduleId': typeof AuthModuleBuilderModuleIdIndexRoute
  '/gameservers/create/import': typeof AuthGlobalGameserversCreateImportRoute
  '/gameservers/update/$gameServerId': typeof AuthGlobalGameserversUpdateGameServerIdRoute
  '/modules/$moduleId/update': typeof AuthGlobalModulesModuleIdUpdateRoute
  '/modules/create/import': typeof AuthGlobalModulesCreateImportRoute
  '/player/$playerId/economy': typeof AuthGlobalPlayerPlayerIdEconomyRoute
  '/player/$playerId/events': typeof AuthGlobalPlayerPlayerIdEventsRoute
  '/player/$playerId/info': typeof AuthGlobalPlayerPlayerIdInfoRoute
  '/player/$playerId/inventory': typeof AuthGlobalPlayerPlayerIdInventoryRoute
  '/roles/update/$roleId': typeof AuthGlobalRolesUpdateRoleIdRoute
  '/roles/view/$roleId': typeof AuthGlobalRolesViewRoleIdRoute
  '/variables/update/$variableId': typeof AuthGlobalVariablesUpdateVariableIdRoute
  '/variables/view/$variableId': typeof AuthGlobalVariablesViewVariableIdRoute
  '/shop/$gameServerId/orders': typeof AuthPlayerShopGameServerIdOrdersRoute
  '/gameserver/$gameServerId/dashboard/console': typeof AuthGameserverGameServerIdDashboardConsoleRoute
  '/gameserver/$gameServerId/dashboard/overview': typeof AuthGameserverGameServerIdDashboardOverviewRoute
  '/gameserver/$gameServerId/dashboard/players': typeof AuthGameserverGameServerIdDashboardPlayersRoute
  '/gameserver/$gameServerId/dashboard/statistics': typeof AuthGameserverGameServerIdDashboardStatisticsRoute
  '/gameserver/$gameServerId/shop/categories': typeof AuthGameserverGameServerIdShopCategoriesRouteWithChildren
  '/gameserver/$gameServerId/shop/orders': typeof AuthGameserverGameServerIdShopOrdersRoute
  '/gameservers/create': typeof AuthGlobalGameserversCreateIndexRoute
  '/modules/create': typeof AuthGlobalModulesCreateIndexRoute
  '/player/$playerId/': typeof AuthGlobalPlayerPlayerIdIndexRoute
  '/settings/billing': typeof AuthGlobalSettingsBillingIndexRoute
  '/shop/$gameServerId/': typeof AuthPlayerShopGameServerIdIndexRoute
  '/gameserver/$gameServerId/shop/': typeof AuthGameserverGameServerIdShopIndexRoute
  '/modules/$moduleId/view/$moduleVersionTag': typeof AuthGlobalModulesModuleIdViewModuleVersionTagRoute
  '/player/$playerId/role/assign': typeof AuthGlobalPlayerPlayerIdRoleAssignRoute
  '/user/$userId/role/assign': typeof AuthGlobalUserUserIdRoleAssignRoute
  '/gameserver/$gameServerId/shop/categories/create': typeof AuthGameserverGameServerIdShopCategoriesCreateRoute
  '/gameserver/$gameServerId/shop/listing/create': typeof AuthGameserverGameServerIdShopListingCreateRoute
  '/modules/$moduleId/view': typeof AuthGlobalModulesModuleIdViewIndexRoute
  '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute
  '/gameserver/$gameServerId/shop/categories/$categoryId/update': typeof AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute
  '/gameserver/$gameServerId/shop/listing/$shopListingId/update': typeof AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute
  '/gameserver/$gameServerId/shop/listing/$shopListingId/view': typeof AuthGameserverGameServerIdShopListingShopListingIdViewRoute
  '/gameserver/$gameServerId/shop/listing/import/file': typeof AuthGameserverGameServerIdShopListingImportFileRoute
  '/gameserver/$gameServerId/shop/listing/import/gameserver': typeof AuthGameserverGameServerIdShopListingImportGameserverRoute
  '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute
  '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute
}

export interface FileRoutesByTo {
  '': typeof AuthPlayerRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/logout-return': typeof LogoutReturnRoute
  '/logout': typeof AuthLogoutRoute
  '/link': typeof SinglePageLinkRoute
  '/dashboard': typeof AuthGlobalDashboardRoute
  '/events': typeof AuthGlobalEventsRoute
  '/gameservers': typeof AuthGlobalGameserversRouteWithChildren
  '/modules': typeof AuthGlobalModulesRouteWithChildren
  '/players': typeof AuthGlobalPlayersRoute
  '/roles': typeof AuthGlobalRolesRouteWithChildren
  '/users': typeof AuthGlobalUsersRoute
  '/variables': typeof AuthGlobalVariablesRouteWithChildren
  '/domain/disabled': typeof AuthDomainDisabledRoute
  '/domain/select': typeof AuthDomainSelectRoute
  '/gameserver/$gameServerId': typeof AuthGameserverGameServerIdRouteWithChildren
  '/account/profile': typeof SinglePageAccountProfileRoute
  '/account/recovery': typeof SinglePageAccountRecoveryRoute
  '/account/verification': typeof SinglePageAccountVerificationRoute
  '/': typeof AuthGlobalIndexRoute
  '/analytics/shop': typeof AuthGlobalAnalyticsShopRoute
  '/roles/create': typeof AuthGlobalRolesCreateRoute
  '/settings/discord': typeof AuthGlobalSettingsDiscordRoute
  '/settings/gameservers': typeof AuthGlobalSettingsGameserversRoute
  '/user/$userId': typeof AuthGlobalUserUserIdRouteWithChildren
  '/variables/create': typeof AuthGlobalVariablesCreateRoute
  '/gameserver/$gameServerId/dashboard': typeof AuthGameserverGameServerIdDashboardRouteWithChildren
  '/gameserver/$gameServerId/items': typeof AuthGameserverGameServerIdItemsRoute
  '/gameserver/$gameServerId/modules': typeof AuthGameserverGameServerIdModulesRouteWithChildren
  '/gameserver/$gameServerId/settings': typeof AuthGameserverGameServerIdSettingsRoute
  '/module-builder/$moduleId/$moduleVersionTag': typeof AuthModuleBuilderModuleIdModuleVersionTagRoute
  '/analytics': typeof AuthGlobalAnalyticsIndexRoute
  '/settings': typeof AuthGlobalSettingsIndexRoute
  '/module-builder/$moduleId': typeof AuthModuleBuilderModuleIdIndexRoute
  '/gameservers/create/import': typeof AuthGlobalGameserversCreateImportRoute
  '/gameservers/update/$gameServerId': typeof AuthGlobalGameserversUpdateGameServerIdRoute
  '/modules/$moduleId/update': typeof AuthGlobalModulesModuleIdUpdateRoute
  '/modules/create/import': typeof AuthGlobalModulesCreateImportRoute
  '/player/$playerId/economy': typeof AuthGlobalPlayerPlayerIdEconomyRoute
  '/player/$playerId/events': typeof AuthGlobalPlayerPlayerIdEventsRoute
  '/player/$playerId/info': typeof AuthGlobalPlayerPlayerIdInfoRoute
  '/player/$playerId/inventory': typeof AuthGlobalPlayerPlayerIdInventoryRoute
  '/roles/update/$roleId': typeof AuthGlobalRolesUpdateRoleIdRoute
  '/roles/view/$roleId': typeof AuthGlobalRolesViewRoleIdRoute
  '/variables/update/$variableId': typeof AuthGlobalVariablesUpdateVariableIdRoute
  '/variables/view/$variableId': typeof AuthGlobalVariablesViewVariableIdRoute
  '/shop/$gameServerId/orders': typeof AuthPlayerShopGameServerIdOrdersRoute
  '/gameserver/$gameServerId/dashboard/console': typeof AuthGameserverGameServerIdDashboardConsoleRoute
  '/gameserver/$gameServerId/dashboard/overview': typeof AuthGameserverGameServerIdDashboardOverviewRoute
  '/gameserver/$gameServerId/dashboard/players': typeof AuthGameserverGameServerIdDashboardPlayersRoute
  '/gameserver/$gameServerId/dashboard/statistics': typeof AuthGameserverGameServerIdDashboardStatisticsRoute
  '/gameserver/$gameServerId/shop/categories': typeof AuthGameserverGameServerIdShopCategoriesRouteWithChildren
  '/gameserver/$gameServerId/shop/orders': typeof AuthGameserverGameServerIdShopOrdersRoute
  '/gameservers/create': typeof AuthGlobalGameserversCreateIndexRoute
  '/modules/create': typeof AuthGlobalModulesCreateIndexRoute
  '/player/$playerId': typeof AuthGlobalPlayerPlayerIdIndexRoute
  '/settings/billing': typeof AuthGlobalSettingsBillingIndexRoute
  '/shop/$gameServerId': typeof AuthPlayerShopGameServerIdIndexRoute
  '/gameserver/$gameServerId/shop': typeof AuthGameserverGameServerIdShopIndexRoute
  '/modules/$moduleId/view/$moduleVersionTag': typeof AuthGlobalModulesModuleIdViewModuleVersionTagRoute
  '/player/$playerId/role/assign': typeof AuthGlobalPlayerPlayerIdRoleAssignRoute
  '/user/$userId/role/assign': typeof AuthGlobalUserUserIdRoleAssignRoute
  '/gameserver/$gameServerId/shop/categories/create': typeof AuthGameserverGameServerIdShopCategoriesCreateRoute
  '/gameserver/$gameServerId/shop/listing/create': typeof AuthGameserverGameServerIdShopListingCreateRoute
  '/modules/$moduleId/view': typeof AuthGlobalModulesModuleIdViewIndexRoute
  '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute
  '/gameserver/$gameServerId/shop/categories/$categoryId/update': typeof AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute
  '/gameserver/$gameServerId/shop/listing/$shopListingId/update': typeof AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute
  '/gameserver/$gameServerId/shop/listing/$shopListingId/view': typeof AuthGameserverGameServerIdShopListingShopListingIdViewRoute
  '/gameserver/$gameServerId/shop/listing/import/file': typeof AuthGameserverGameServerIdShopListingImportFileRoute
  '/gameserver/$gameServerId/shop/listing/import/gameserver': typeof AuthGameserverGameServerIdShopListingImportGameserverRoute
  '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute
  '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_single-page': typeof SinglePageRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/login': typeof LoginRoute
  '/logout-return': typeof LogoutReturnRoute
  '/_auth/_global': typeof AuthGlobalRouteWithChildren
  '/_auth/_player': typeof AuthPlayerRouteWithChildren
  '/_auth/logout': typeof AuthLogoutRoute
  '/_single-page/link': typeof SinglePageLinkRoute
  '/_auth/_global/analytics': typeof AuthGlobalAnalyticsRouteWithChildren
  '/_auth/_global/dashboard': typeof AuthGlobalDashboardRoute
  '/_auth/_global/events': typeof AuthGlobalEventsRoute
  '/_auth/_global/gameservers': typeof AuthGlobalGameserversRouteWithChildren
  '/_auth/_global/modules': typeof AuthGlobalModulesRouteWithChildren
  '/_auth/_global/players': typeof AuthGlobalPlayersRoute
  '/_auth/_global/roles': typeof AuthGlobalRolesRouteWithChildren
  '/_auth/_global/settings': typeof AuthGlobalSettingsRouteWithChildren
  '/_auth/_global/users': typeof AuthGlobalUsersRoute
  '/_auth/_global/variables': typeof AuthGlobalVariablesRouteWithChildren
  '/_auth/domain/disabled': typeof AuthDomainDisabledRoute
  '/_auth/domain/select': typeof AuthDomainSelectRoute
  '/_auth/gameserver/$gameServerId': typeof AuthGameserverGameServerIdRouteWithChildren
  '/_single-page/account/profile': typeof SinglePageAccountProfileRoute
  '/_single-page/account/recovery': typeof SinglePageAccountRecoveryRoute
  '/_single-page/account/verification': typeof SinglePageAccountVerificationRoute
  '/_auth/_global/': typeof AuthGlobalIndexRoute
  '/_auth/_global/analytics/shop': typeof AuthGlobalAnalyticsShopRoute
  '/_auth/_global/player/$playerId': typeof AuthGlobalPlayerPlayerIdRouteWithChildren
  '/_auth/_global/roles/create': typeof AuthGlobalRolesCreateRoute
  '/_auth/_global/settings/discord': typeof AuthGlobalSettingsDiscordRoute
  '/_auth/_global/settings/gameservers': typeof AuthGlobalSettingsGameserversRoute
  '/_auth/_global/user/$userId': typeof AuthGlobalUserUserIdRouteWithChildren
  '/_auth/_global/variables/create': typeof AuthGlobalVariablesCreateRoute
  '/_auth/_player/shop/$gameServerId': typeof AuthPlayerShopGameServerIdRouteWithChildren
  '/_auth/gameserver/$gameServerId/dashboard': typeof AuthGameserverGameServerIdDashboardRouteWithChildren
  '/_auth/gameserver/$gameServerId/items': typeof AuthGameserverGameServerIdItemsRoute
  '/_auth/gameserver/$gameServerId/modules': typeof AuthGameserverGameServerIdModulesRouteWithChildren
  '/_auth/gameserver/$gameServerId/settings': typeof AuthGameserverGameServerIdSettingsRoute
  '/_auth/gameserver/$gameServerId/shop': typeof AuthGameserverGameServerIdShopRouteWithChildren
  '/_auth/module-builder/$moduleId/$moduleVersionTag': typeof AuthModuleBuilderModuleIdModuleVersionTagRoute
  '/_auth/_global/analytics/': typeof AuthGlobalAnalyticsIndexRoute
  '/_auth/_global/settings/': typeof AuthGlobalSettingsIndexRoute
  '/_auth/module-builder/$moduleId/': typeof AuthModuleBuilderModuleIdIndexRoute
  '/_auth/_global/gameservers/create/import': typeof AuthGlobalGameserversCreateImportRoute
  '/_auth/_global/gameservers/update/$gameServerId': typeof AuthGlobalGameserversUpdateGameServerIdRoute
  '/_auth/_global/modules/$moduleId/update': typeof AuthGlobalModulesModuleIdUpdateRoute
  '/_auth/_global/modules/create/import': typeof AuthGlobalModulesCreateImportRoute
  '/_auth/_global/player/$playerId/economy': typeof AuthGlobalPlayerPlayerIdEconomyRoute
  '/_auth/_global/player/$playerId/events': typeof AuthGlobalPlayerPlayerIdEventsRoute
  '/_auth/_global/player/$playerId/info': typeof AuthGlobalPlayerPlayerIdInfoRoute
  '/_auth/_global/player/$playerId/inventory': typeof AuthGlobalPlayerPlayerIdInventoryRoute
  '/_auth/_global/roles/update/$roleId': typeof AuthGlobalRolesUpdateRoleIdRoute
  '/_auth/_global/roles/view/$roleId': typeof AuthGlobalRolesViewRoleIdRoute
  '/_auth/_global/variables/update/$variableId': typeof AuthGlobalVariablesUpdateVariableIdRoute
  '/_auth/_global/variables/view/$variableId': typeof AuthGlobalVariablesViewVariableIdRoute
  '/_auth/_player/shop/$gameServerId/orders': typeof AuthPlayerShopGameServerIdOrdersRoute
  '/_auth/gameserver/$gameServerId/dashboard/console': typeof AuthGameserverGameServerIdDashboardConsoleRoute
  '/_auth/gameserver/$gameServerId/dashboard/overview': typeof AuthGameserverGameServerIdDashboardOverviewRoute
  '/_auth/gameserver/$gameServerId/dashboard/players': typeof AuthGameserverGameServerIdDashboardPlayersRoute
  '/_auth/gameserver/$gameServerId/dashboard/statistics': typeof AuthGameserverGameServerIdDashboardStatisticsRoute
  '/_auth/gameserver/$gameServerId/shop/categories': typeof AuthGameserverGameServerIdShopCategoriesRouteWithChildren
  '/_auth/gameserver/$gameServerId/shop/orders': typeof AuthGameserverGameServerIdShopOrdersRoute
  '/_auth/_global/gameservers/create/': typeof AuthGlobalGameserversCreateIndexRoute
  '/_auth/_global/modules/create/': typeof AuthGlobalModulesCreateIndexRoute
  '/_auth/_global/player/$playerId/': typeof AuthGlobalPlayerPlayerIdIndexRoute
  '/_auth/_global/settings/billing/': typeof AuthGlobalSettingsBillingIndexRoute
  '/_auth/_player/shop/$gameServerId/': typeof AuthPlayerShopGameServerIdIndexRoute
  '/_auth/gameserver/$gameServerId/shop/': typeof AuthGameserverGameServerIdShopIndexRoute
  '/_auth/_global/modules/$moduleId/view/$moduleVersionTag': typeof AuthGlobalModulesModuleIdViewModuleVersionTagRoute
  '/_auth/_global/player/$playerId/role/assign': typeof AuthGlobalPlayerPlayerIdRoleAssignRoute
  '/_auth/_global/user/$userId/role/assign': typeof AuthGlobalUserUserIdRoleAssignRoute
  '/_auth/gameserver/$gameServerId/shop/categories/create': typeof AuthGameserverGameServerIdShopCategoriesCreateRoute
  '/_auth/gameserver/$gameServerId/shop/listing/create': typeof AuthGameserverGameServerIdShopListingCreateRoute
  '/_auth/_global/modules/$moduleId/view/': typeof AuthGlobalModulesModuleIdViewIndexRoute
  '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagUpdateRoute
  '/_auth/gameserver/$gameServerId/shop/categories/$categoryId/update': typeof AuthGameserverGameServerIdShopCategoriesCategoryIdUpdateRoute
  '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/update': typeof AuthGameserverGameServerIdShopListingShopListingIdUpdateRoute
  '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/view': typeof AuthGameserverGameServerIdShopListingShopListingIdViewRoute
  '/_auth/gameserver/$gameServerId/shop/listing/import/file': typeof AuthGameserverGameServerIdShopListingImportFileRoute
  '/_auth/gameserver/$gameServerId/shop/listing/import/gameserver': typeof AuthGameserverGameServerIdShopListingImportGameserverRoute
  '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallViewRoute
  '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/': typeof AuthGameserverGameServerIdModulesModuleIdModuleVersionTagInstallIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/forbidden'
    | '/login'
    | '/logout-return'
    | '/logout'
    | '/link'
    | '/analytics'
    | '/dashboard'
    | '/events'
    | '/gameservers'
    | '/modules'
    | '/players'
    | '/roles'
    | '/settings'
    | '/users'
    | '/variables'
    | '/domain/disabled'
    | '/domain/select'
    | '/gameserver/$gameServerId'
    | '/account/profile'
    | '/account/recovery'
    | '/account/verification'
    | '/'
    | '/analytics/shop'
    | '/player/$playerId'
    | '/roles/create'
    | '/settings/discord'
    | '/settings/gameservers'
    | '/user/$userId'
    | '/variables/create'
    | '/shop/$gameServerId'
    | '/gameserver/$gameServerId/dashboard'
    | '/gameserver/$gameServerId/items'
    | '/gameserver/$gameServerId/modules'
    | '/gameserver/$gameServerId/settings'
    | '/gameserver/$gameServerId/shop'
    | '/module-builder/$moduleId/$moduleVersionTag'
    | '/analytics/'
    | '/settings/'
    | '/module-builder/$moduleId'
    | '/gameservers/create/import'
    | '/gameservers/update/$gameServerId'
    | '/modules/$moduleId/update'
    | '/modules/create/import'
    | '/player/$playerId/economy'
    | '/player/$playerId/events'
    | '/player/$playerId/info'
    | '/player/$playerId/inventory'
    | '/roles/update/$roleId'
    | '/roles/view/$roleId'
    | '/variables/update/$variableId'
    | '/variables/view/$variableId'
    | '/shop/$gameServerId/orders'
    | '/gameserver/$gameServerId/dashboard/console'
    | '/gameserver/$gameServerId/dashboard/overview'
    | '/gameserver/$gameServerId/dashboard/players'
    | '/gameserver/$gameServerId/dashboard/statistics'
    | '/gameserver/$gameServerId/shop/categories'
    | '/gameserver/$gameServerId/shop/orders'
    | '/gameservers/create'
    | '/modules/create'
    | '/player/$playerId/'
    | '/settings/billing'
    | '/shop/$gameServerId/'
    | '/gameserver/$gameServerId/shop/'
    | '/modules/$moduleId/view/$moduleVersionTag'
    | '/player/$playerId/role/assign'
    | '/user/$userId/role/assign'
    | '/gameserver/$gameServerId/shop/categories/create'
    | '/gameserver/$gameServerId/shop/listing/create'
    | '/modules/$moduleId/view'
    | '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update'
    | '/gameserver/$gameServerId/shop/categories/$categoryId/update'
    | '/gameserver/$gameServerId/shop/listing/$shopListingId/update'
    | '/gameserver/$gameServerId/shop/listing/$shopListingId/view'
    | '/gameserver/$gameServerId/shop/listing/import/file'
    | '/gameserver/$gameServerId/shop/listing/import/gameserver'
    | '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view'
    | '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install'
  fileRoutesByTo: FileRoutesByTo
  to:
    | ''
    | '/forbidden'
    | '/login'
    | '/logout-return'
    | '/logout'
    | '/link'
    | '/dashboard'
    | '/events'
    | '/gameservers'
    | '/modules'
    | '/players'
    | '/roles'
    | '/users'
    | '/variables'
    | '/domain/disabled'
    | '/domain/select'
    | '/gameserver/$gameServerId'
    | '/account/profile'
    | '/account/recovery'
    | '/account/verification'
    | '/'
    | '/analytics/shop'
    | '/roles/create'
    | '/settings/discord'
    | '/settings/gameservers'
    | '/user/$userId'
    | '/variables/create'
    | '/gameserver/$gameServerId/dashboard'
    | '/gameserver/$gameServerId/items'
    | '/gameserver/$gameServerId/modules'
    | '/gameserver/$gameServerId/settings'
    | '/module-builder/$moduleId/$moduleVersionTag'
    | '/analytics'
    | '/settings'
    | '/module-builder/$moduleId'
    | '/gameservers/create/import'
    | '/gameservers/update/$gameServerId'
    | '/modules/$moduleId/update'
    | '/modules/create/import'
    | '/player/$playerId/economy'
    | '/player/$playerId/events'
    | '/player/$playerId/info'
    | '/player/$playerId/inventory'
    | '/roles/update/$roleId'
    | '/roles/view/$roleId'
    | '/variables/update/$variableId'
    | '/variables/view/$variableId'
    | '/shop/$gameServerId/orders'
    | '/gameserver/$gameServerId/dashboard/console'
    | '/gameserver/$gameServerId/dashboard/overview'
    | '/gameserver/$gameServerId/dashboard/players'
    | '/gameserver/$gameServerId/dashboard/statistics'
    | '/gameserver/$gameServerId/shop/categories'
    | '/gameserver/$gameServerId/shop/orders'
    | '/gameservers/create'
    | '/modules/create'
    | '/player/$playerId'
    | '/settings/billing'
    | '/shop/$gameServerId'
    | '/gameserver/$gameServerId/shop'
    | '/modules/$moduleId/view/$moduleVersionTag'
    | '/player/$playerId/role/assign'
    | '/user/$userId/role/assign'
    | '/gameserver/$gameServerId/shop/categories/create'
    | '/gameserver/$gameServerId/shop/listing/create'
    | '/modules/$moduleId/view'
    | '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update'
    | '/gameserver/$gameServerId/shop/categories/$categoryId/update'
    | '/gameserver/$gameServerId/shop/listing/$shopListingId/update'
    | '/gameserver/$gameServerId/shop/listing/$shopListingId/view'
    | '/gameserver/$gameServerId/shop/listing/import/file'
    | '/gameserver/$gameServerId/shop/listing/import/gameserver'
    | '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view'
    | '/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install'
  id:
    | '__root__'
    | '/_auth'
    | '/_single-page'
    | '/forbidden'
    | '/login'
    | '/logout-return'
    | '/_auth/_global'
    | '/_auth/_player'
    | '/_auth/logout'
    | '/_single-page/link'
    | '/_auth/_global/analytics'
    | '/_auth/_global/dashboard'
    | '/_auth/_global/events'
    | '/_auth/_global/gameservers'
    | '/_auth/_global/modules'
    | '/_auth/_global/players'
    | '/_auth/_global/roles'
    | '/_auth/_global/settings'
    | '/_auth/_global/users'
    | '/_auth/_global/variables'
    | '/_auth/domain/disabled'
    | '/_auth/domain/select'
    | '/_auth/gameserver/$gameServerId'
    | '/_single-page/account/profile'
    | '/_single-page/account/recovery'
    | '/_single-page/account/verification'
    | '/_auth/_global/'
    | '/_auth/_global/analytics/shop'
    | '/_auth/_global/player/$playerId'
    | '/_auth/_global/roles/create'
    | '/_auth/_global/settings/discord'
    | '/_auth/_global/settings/gameservers'
    | '/_auth/_global/user/$userId'
    | '/_auth/_global/variables/create'
    | '/_auth/_player/shop/$gameServerId'
    | '/_auth/gameserver/$gameServerId/dashboard'
    | '/_auth/gameserver/$gameServerId/items'
    | '/_auth/gameserver/$gameServerId/modules'
    | '/_auth/gameserver/$gameServerId/settings'
    | '/_auth/gameserver/$gameServerId/shop'
    | '/_auth/module-builder/$moduleId/$moduleVersionTag'
    | '/_auth/_global/analytics/'
    | '/_auth/_global/settings/'
    | '/_auth/module-builder/$moduleId/'
    | '/_auth/_global/gameservers/create/import'
    | '/_auth/_global/gameservers/update/$gameServerId'
    | '/_auth/_global/modules/$moduleId/update'
    | '/_auth/_global/modules/create/import'
    | '/_auth/_global/player/$playerId/economy'
    | '/_auth/_global/player/$playerId/events'
    | '/_auth/_global/player/$playerId/info'
    | '/_auth/_global/player/$playerId/inventory'
    | '/_auth/_global/roles/update/$roleId'
    | '/_auth/_global/roles/view/$roleId'
    | '/_auth/_global/variables/update/$variableId'
    | '/_auth/_global/variables/view/$variableId'
    | '/_auth/_player/shop/$gameServerId/orders'
    | '/_auth/gameserver/$gameServerId/dashboard/console'
    | '/_auth/gameserver/$gameServerId/dashboard/overview'
    | '/_auth/gameserver/$gameServerId/dashboard/players'
    | '/_auth/gameserver/$gameServerId/dashboard/statistics'
    | '/_auth/gameserver/$gameServerId/shop/categories'
    | '/_auth/gameserver/$gameServerId/shop/orders'
    | '/_auth/_global/gameservers/create/'
    | '/_auth/_global/modules/create/'
    | '/_auth/_global/player/$playerId/'
    | '/_auth/_global/settings/billing/'
    | '/_auth/_player/shop/$gameServerId/'
    | '/_auth/gameserver/$gameServerId/shop/'
    | '/_auth/_global/modules/$moduleId/view/$moduleVersionTag'
    | '/_auth/_global/player/$playerId/role/assign'
    | '/_auth/_global/user/$userId/role/assign'
    | '/_auth/gameserver/$gameServerId/shop/categories/create'
    | '/_auth/gameserver/$gameServerId/shop/listing/create'
    | '/_auth/_global/modules/$moduleId/view/'
    | '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update'
    | '/_auth/gameserver/$gameServerId/shop/categories/$categoryId/update'
    | '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/update'
    | '/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/view'
    | '/_auth/gameserver/$gameServerId/shop/listing/import/file'
    | '/_auth/gameserver/$gameServerId/shop/listing/import/gameserver'
    | '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view'
    | '/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  SinglePageRoute: typeof SinglePageRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  LoginRoute: typeof LoginRoute
  LogoutReturnRoute: typeof LogoutReturnRoute
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  SinglePageRoute: SinglePageRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  LoginRoute: LoginRoute,
  LogoutReturnRoute: LogoutReturnRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/_single-page",
        "/forbidden",
        "/login",
        "/logout-return"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/_global",
        "/_auth/_player",
        "/_auth/logout",
        "/_auth/domain/disabled",
        "/_auth/domain/select",
        "/_auth/gameserver/$gameServerId",
        "/_auth/module-builder/$moduleId/$moduleVersionTag",
        "/_auth/module-builder/$moduleId/"
      ]
    },
    "/_single-page": {
      "filePath": "_single-page.tsx",
      "children": [
        "/_single-page/link",
        "/_single-page/account/profile",
        "/_single-page/account/recovery",
        "/_single-page/account/verification"
      ]
    },
    "/forbidden": {
      "filePath": "forbidden.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout-return": {
      "filePath": "logout-return.tsx"
    },
    "/_auth/_global": {
      "filePath": "_auth/_global.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_global/analytics",
        "/_auth/_global/dashboard",
        "/_auth/_global/events",
        "/_auth/_global/gameservers",
        "/_auth/_global/modules",
        "/_auth/_global/players",
        "/_auth/_global/roles",
        "/_auth/_global/settings",
        "/_auth/_global/users",
        "/_auth/_global/variables",
        "/_auth/_global/",
        "/_auth/_global/player/$playerId",
        "/_auth/_global/user/$userId"
      ]
    },
    "/_auth/_player": {
      "filePath": "_auth/_player.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/_player/shop/$gameServerId"
      ]
    },
    "/_auth/logout": {
      "filePath": "_auth/logout.tsx",
      "parent": "/_auth"
    },
    "/_single-page/link": {
      "filePath": "_single-page/link.tsx",
      "parent": "/_single-page"
    },
    "/_auth/_global/analytics": {
      "filePath": "_auth/_global/analytics.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/analytics/shop",
        "/_auth/_global/analytics/"
      ]
    },
    "/_auth/_global/dashboard": {
      "filePath": "_auth/_global/dashboard.tsx",
      "parent": "/_auth/_global"
    },
    "/_auth/_global/events": {
      "filePath": "_auth/_global/events.tsx",
      "parent": "/_auth/_global"
    },
    "/_auth/_global/gameservers": {
      "filePath": "_auth/_global/gameservers.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/gameservers/create/import",
        "/_auth/_global/gameservers/update/$gameServerId",
        "/_auth/_global/gameservers/create/"
      ]
    },
    "/_auth/_global/modules": {
      "filePath": "_auth/_global/modules.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/modules/$moduleId/update",
        "/_auth/_global/modules/create/import",
        "/_auth/_global/modules/create/",
        "/_auth/_global/modules/$moduleId/view/$moduleVersionTag",
        "/_auth/_global/modules/$moduleId/view/"
      ]
    },
    "/_auth/_global/players": {
      "filePath": "_auth/_global/players.tsx",
      "parent": "/_auth/_global"
    },
    "/_auth/_global/roles": {
      "filePath": "_auth/_global/roles.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/roles/create",
        "/_auth/_global/roles/update/$roleId",
        "/_auth/_global/roles/view/$roleId"
      ]
    },
    "/_auth/_global/settings": {
      "filePath": "_auth/_global/settings.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/settings/discord",
        "/_auth/_global/settings/gameservers",
        "/_auth/_global/settings/",
        "/_auth/_global/settings/billing/"
      ]
    },
    "/_auth/_global/users": {
      "filePath": "_auth/_global/users.tsx",
      "parent": "/_auth/_global"
    },
    "/_auth/_global/variables": {
      "filePath": "_auth/_global/variables.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/variables/create",
        "/_auth/_global/variables/update/$variableId",
        "/_auth/_global/variables/view/$variableId"
      ]
    },
    "/_auth/domain/disabled": {
      "filePath": "_auth/domain.disabled.tsx",
      "parent": "/_auth"
    },
    "/_auth/domain/select": {
      "filePath": "_auth/domain.select.tsx",
      "parent": "/_auth"
    },
    "/_auth/gameserver/$gameServerId": {
      "filePath": "_auth/gameserver.$gameServerId.tsx",
      "parent": "/_auth",
      "children": [
        "/_auth/gameserver/$gameServerId/dashboard",
        "/_auth/gameserver/$gameServerId/items",
        "/_auth/gameserver/$gameServerId/modules",
        "/_auth/gameserver/$gameServerId/settings",
        "/_auth/gameserver/$gameServerId/shop"
      ]
    },
    "/_single-page/account/profile": {
      "filePath": "_single-page/account.profile.tsx",
      "parent": "/_single-page"
    },
    "/_single-page/account/recovery": {
      "filePath": "_single-page/account.recovery.tsx",
      "parent": "/_single-page"
    },
    "/_single-page/account/verification": {
      "filePath": "_single-page/account.verification.tsx",
      "parent": "/_single-page"
    },
    "/_auth/_global/": {
      "filePath": "_auth/_global/index.tsx",
      "parent": "/_auth/_global"
    },
    "/_auth/_global/analytics/shop": {
      "filePath": "_auth/_global/analytics/shop.tsx",
      "parent": "/_auth/_global/analytics"
    },
    "/_auth/_global/player/$playerId": {
      "filePath": "_auth/_global/player.$playerId.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/player/$playerId/economy",
        "/_auth/_global/player/$playerId/events",
        "/_auth/_global/player/$playerId/info",
        "/_auth/_global/player/$playerId/inventory",
        "/_auth/_global/player/$playerId/",
        "/_auth/_global/player/$playerId/role/assign"
      ]
    },
    "/_auth/_global/roles/create": {
      "filePath": "_auth/_global/roles.create.tsx",
      "parent": "/_auth/_global/roles"
    },
    "/_auth/_global/settings/discord": {
      "filePath": "_auth/_global/settings/discord.tsx",
      "parent": "/_auth/_global/settings"
    },
    "/_auth/_global/settings/gameservers": {
      "filePath": "_auth/_global/settings/gameservers.tsx",
      "parent": "/_auth/_global/settings"
    },
    "/_auth/_global/user/$userId": {
      "filePath": "_auth/_global/user.$userId.tsx",
      "parent": "/_auth/_global",
      "children": [
        "/_auth/_global/user/$userId/role/assign"
      ]
    },
    "/_auth/_global/variables/create": {
      "filePath": "_auth/_global/variables.create.tsx",
      "parent": "/_auth/_global/variables"
    },
    "/_auth/_player/shop/$gameServerId": {
      "filePath": "_auth/_player/shop.$gameServerId.tsx",
      "parent": "/_auth/_player",
      "children": [
        "/_auth/_player/shop/$gameServerId/orders",
        "/_auth/_player/shop/$gameServerId/"
      ]
    },
    "/_auth/gameserver/$gameServerId/dashboard": {
      "filePath": "_auth/gameserver.$gameServerId/dashboard.tsx",
      "parent": "/_auth/gameserver/$gameServerId",
      "children": [
        "/_auth/gameserver/$gameServerId/dashboard/console",
        "/_auth/gameserver/$gameServerId/dashboard/overview",
        "/_auth/gameserver/$gameServerId/dashboard/players",
        "/_auth/gameserver/$gameServerId/dashboard/statistics"
      ]
    },
    "/_auth/gameserver/$gameServerId/items": {
      "filePath": "_auth/gameserver.$gameServerId/items.tsx",
      "parent": "/_auth/gameserver/$gameServerId"
    },
    "/_auth/gameserver/$gameServerId/modules": {
      "filePath": "_auth/gameserver.$gameServerId/modules.tsx",
      "parent": "/_auth/gameserver/$gameServerId",
      "children": [
        "/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update",
        "/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view",
        "/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/"
      ]
    },
    "/_auth/gameserver/$gameServerId/settings": {
      "filePath": "_auth/gameserver.$gameServerId/settings.tsx",
      "parent": "/_auth/gameserver/$gameServerId"
    },
    "/_auth/gameserver/$gameServerId/shop": {
      "filePath": "_auth/gameserver.$gameServerId/shop.tsx",
      "parent": "/_auth/gameserver/$gameServerId",
      "children": [
        "/_auth/gameserver/$gameServerId/shop/categories",
        "/_auth/gameserver/$gameServerId/shop/orders",
        "/_auth/gameserver/$gameServerId/shop/",
        "/_auth/gameserver/$gameServerId/shop/listing/create",
        "/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/update",
        "/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/view",
        "/_auth/gameserver/$gameServerId/shop/listing/import/file",
        "/_auth/gameserver/$gameServerId/shop/listing/import/gameserver"
      ]
    },
    "/_auth/module-builder/$moduleId/$moduleVersionTag": {
      "filePath": "_auth/module-builder.$moduleId.$moduleVersionTag.tsx",
      "parent": "/_auth"
    },
    "/_auth/_global/analytics/": {
      "filePath": "_auth/_global/analytics/index.tsx",
      "parent": "/_auth/_global/analytics"
    },
    "/_auth/_global/settings/": {
      "filePath": "_auth/_global/settings/index.tsx",
      "parent": "/_auth/_global/settings"
    },
    "/_auth/module-builder/$moduleId/": {
      "filePath": "_auth/module-builder.$moduleId.index.tsx",
      "parent": "/_auth"
    },
    "/_auth/_global/gameservers/create/import": {
      "filePath": "_auth/_global/gameservers.create.import.tsx",
      "parent": "/_auth/_global/gameservers"
    },
    "/_auth/_global/gameservers/update/$gameServerId": {
      "filePath": "_auth/_global/gameservers.update.$gameServerId.tsx",
      "parent": "/_auth/_global/gameservers"
    },
    "/_auth/_global/modules/$moduleId/update": {
      "filePath": "_auth/_global/modules.$moduleId.update.tsx",
      "parent": "/_auth/_global/modules"
    },
    "/_auth/_global/modules/create/import": {
      "filePath": "_auth/_global/modules.create.import.tsx",
      "parent": "/_auth/_global/modules"
    },
    "/_auth/_global/player/$playerId/economy": {
      "filePath": "_auth/_global/player.$playerId/economy.tsx",
      "parent": "/_auth/_global/player/$playerId"
    },
    "/_auth/_global/player/$playerId/events": {
      "filePath": "_auth/_global/player.$playerId/events.tsx",
      "parent": "/_auth/_global/player/$playerId"
    },
    "/_auth/_global/player/$playerId/info": {
      "filePath": "_auth/_global/player.$playerId/info.tsx",
      "parent": "/_auth/_global/player/$playerId"
    },
    "/_auth/_global/player/$playerId/inventory": {
      "filePath": "_auth/_global/player.$playerId/inventory.tsx",
      "parent": "/_auth/_global/player/$playerId"
    },
    "/_auth/_global/roles/update/$roleId": {
      "filePath": "_auth/_global/roles.update.$roleId.tsx",
      "parent": "/_auth/_global/roles"
    },
    "/_auth/_global/roles/view/$roleId": {
      "filePath": "_auth/_global/roles.view.$roleId.tsx",
      "parent": "/_auth/_global/roles"
    },
    "/_auth/_global/variables/update/$variableId": {
      "filePath": "_auth/_global/variables.update.$variableId.tsx",
      "parent": "/_auth/_global/variables"
    },
    "/_auth/_global/variables/view/$variableId": {
      "filePath": "_auth/_global/variables.view.$variableId.tsx",
      "parent": "/_auth/_global/variables"
    },
    "/_auth/_player/shop/$gameServerId/orders": {
      "filePath": "_auth/_player/shop.$gameServerId.orders.tsx",
      "parent": "/_auth/_player/shop/$gameServerId"
    },
    "/_auth/gameserver/$gameServerId/dashboard/console": {
      "filePath": "_auth/gameserver.$gameServerId/dashboard.console.tsx",
      "parent": "/_auth/gameserver/$gameServerId/dashboard"
    },
    "/_auth/gameserver/$gameServerId/dashboard/overview": {
      "filePath": "_auth/gameserver.$gameServerId/dashboard.overview.tsx",
      "parent": "/_auth/gameserver/$gameServerId/dashboard"
    },
    "/_auth/gameserver/$gameServerId/dashboard/players": {
      "filePath": "_auth/gameserver.$gameServerId/dashboard.players.tsx",
      "parent": "/_auth/gameserver/$gameServerId/dashboard"
    },
    "/_auth/gameserver/$gameServerId/dashboard/statistics": {
      "filePath": "_auth/gameserver.$gameServerId/dashboard.statistics.tsx",
      "parent": "/_auth/gameserver/$gameServerId/dashboard"
    },
    "/_auth/gameserver/$gameServerId/shop/categories": {
      "filePath": "_auth/gameserver.$gameServerId/shop.categories.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop",
      "children": [
        "/_auth/gameserver/$gameServerId/shop/categories/create",
        "/_auth/gameserver/$gameServerId/shop/categories/$categoryId/update"
      ]
    },
    "/_auth/gameserver/$gameServerId/shop/orders": {
      "filePath": "_auth/gameserver.$gameServerId/shop.orders.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/_global/gameservers/create/": {
      "filePath": "_auth/_global/gameservers.create.index.tsx",
      "parent": "/_auth/_global/gameservers"
    },
    "/_auth/_global/modules/create/": {
      "filePath": "_auth/_global/modules.create.index.tsx",
      "parent": "/_auth/_global/modules"
    },
    "/_auth/_global/player/$playerId/": {
      "filePath": "_auth/_global/player.$playerId/index.tsx",
      "parent": "/_auth/_global/player/$playerId"
    },
    "/_auth/_global/settings/billing/": {
      "filePath": "_auth/_global/settings/billing/index.tsx",
      "parent": "/_auth/_global/settings"
    },
    "/_auth/_player/shop/$gameServerId/": {
      "filePath": "_auth/_player/shop.$gameServerId.index.tsx",
      "parent": "/_auth/_player/shop/$gameServerId"
    },
    "/_auth/gameserver/$gameServerId/shop/": {
      "filePath": "_auth/gameserver.$gameServerId/shop.index.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/_global/modules/$moduleId/view/$moduleVersionTag": {
      "filePath": "_auth/_global/modules.$moduleId.view.$moduleVersionTag.tsx",
      "parent": "/_auth/_global/modules"
    },
    "/_auth/_global/player/$playerId/role/assign": {
      "filePath": "_auth/_global/player.$playerId/role.assign.tsx",
      "parent": "/_auth/_global/player/$playerId"
    },
    "/_auth/_global/user/$userId/role/assign": {
      "filePath": "_auth/_global/user.$userId.role.assign.tsx",
      "parent": "/_auth/_global/user/$userId"
    },
    "/_auth/gameserver/$gameServerId/shop/categories/create": {
      "filePath": "_auth/gameserver.$gameServerId/shop.categories.create.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop/categories"
    },
    "/_auth/gameserver/$gameServerId/shop/listing/create": {
      "filePath": "_auth/gameserver.$gameServerId/shop.listing.create.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/_global/modules/$moduleId/view/": {
      "filePath": "_auth/_global/modules.$moduleId.view.index.tsx",
      "parent": "/_auth/_global/modules"
    },
    "/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/update": {
      "filePath": "_auth/gameserver.$gameServerId/modules.$moduleId.$moduleVersionTag.update.tsx",
      "parent": "/_auth/gameserver/$gameServerId/modules"
    },
    "/_auth/gameserver/$gameServerId/shop/categories/$categoryId/update": {
      "filePath": "_auth/gameserver.$gameServerId/shop.categories.$categoryId.update.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop/categories"
    },
    "/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/update": {
      "filePath": "_auth/gameserver.$gameServerId/shop.listing.$shopListingId.update.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/gameserver/$gameServerId/shop/listing/$shopListingId/view": {
      "filePath": "_auth/gameserver.$gameServerId/shop.listing.$shopListingId.view.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/gameserver/$gameServerId/shop/listing/import/file": {
      "filePath": "_auth/gameserver.$gameServerId/shop.listing.import.file.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/gameserver/$gameServerId/shop/listing/import/gameserver": {
      "filePath": "_auth/gameserver.$gameServerId/shop.listing.import.gameserver.tsx",
      "parent": "/_auth/gameserver/$gameServerId/shop"
    },
    "/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/view": {
      "filePath": "_auth/gameserver.$gameServerId/modules.$moduleId.$moduleVersionTag.install.view.tsx",
      "parent": "/_auth/gameserver/$gameServerId/modules"
    },
    "/_auth/gameserver/$gameServerId/modules/$moduleId/$moduleVersionTag/install/": {
      "filePath": "_auth/gameserver.$gameServerId/modules.$moduleId.$moduleVersionTag.install.index.tsx",
      "parent": "/_auth/gameserver/$gameServerId/modules"
    }
  }
}
ROUTE_MANIFEST_END */
